import React, { Fragment, useState } from 'react'
import { Paper, Typography } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import SaveIcon from '@mui/icons-material/Save';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import { useDispatch, useSelector } from 'react-redux'
import { useStateIfMounted } from 'use-state-if-mounted'
import {
    ObtenerClientePorLogin36,
    obtenerContadorDeFechaFolio,
    agregarMediosContacto,
    editarMediosContacto,
    eliminarFC_36AnexoMedioContactoBD,
    actualizarFC_36Solicitud,
    agregarRepresentanteLegal,
    editarRepresentanteLegal,
    eliminarFC_36AnexoRepresentanteLegalBD,
    agregarPersonaAutorizada,
    editarPersonaAutorizada,
    eliminarFC_36AnexoPersonaAutorizadaBD,
    agregarDomicilioFiscal,
    editarDomicilioFiscal,
    agregarMarcas,
    editarMarcas,
    editarResponsableInstalacion,
    agregarResponsableInstalacion,
    agregarPredios, editarPredios,
    agregarViveros, editarViveros,
    agregarFC_36ActividadesEmpresa,
    agregarFC_36,
    agregarMarcasBebidas, editarMarcasBebidas,
    editarFC_36AnexoInstalacion, editarInstalacionBajaAlta,

    actualizarFC_36PaginaActiva,
    registrarSolicitudFC_36Accion,
    actualizarFC_36Estatus,
    resetDataFC_36,
    setCambiosFC_36SolicitudBorrador,
    setCambiosFC_36SolicitudNueva, editarFC_36
} from '../../../redux/DucksBeneficiario/FC_36Ducks'
import { v4 as uuidv4 } from 'uuid';
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import ToolBarPaginas from '../../App/ToolBarPaginas';
import TablaAnexosFC36 from './TablaAnexosFC36';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import estilos from './FormularioFC36BeneficiarioComponent.module.css'
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
import BotonAtrasSiguienteComponent from '../../App/BotonAtrasSiguienteComponent';
import InfoBar from '../../App/InfoBar'
import { ca } from 'date-fns/locale';
import TerminosYCondicionesComponent from '../../App/TerminosYCondicionesComponent';
import TablaMediosContacto from './TablasAnexos/TablaMediosContacto'
import TablaMarcas from './TablasAnexos/TablaMarcas'
import TablaMarcasBebidasConMezcal from './TablasAnexos/TablaMarcasBebidasConMezcal'
import TablaRepresentantesLegales from './TablasAnexos/TablaRepresentantesLegales'
import TablaPersonasAutorizadas from './TablasAnexos/TablaPersonasAutorizadas'
import TablaPredio from './TablasAnexos/TablaPredio'
import TablaVivero from './TablasAnexos/TablaVivero'
import { Formik } from 'formik'
import { obtenerColoniasPorCpApi, obtenerCPsPorMunicipioApi, obtenerEstadosApi, obtenerLocalidadesPorEstadoYMunicipioApi, obtenerCallesPorClavesEstadoMunicipioLocalidad, obtenerEstadosConClaveApi, obtenerMunicipiosConClavePorEstadoApi } from '../../../redux/DucksApis/CopomexDucks';
import TablaAnexos from './TablasAnexos/TablaAnexos';
import Tooltip from '@mui/material/Tooltip';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import TablaDomicilio from './TablasAnexos/TablaDomicilio'
import ModalDetalleMarcas from './TablasAnexos/ModalDetalleMarcas';
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import { obtenerSolicitudesWithStatus } from '../../../redux/SolicitudesDucks';
import DocumentacionFC_36Component from './DocumentacionFC_36Component';
import { Co2Sharp } from '@mui/icons-material';
import TablaResponsablesInstalaciones from './TablasAnexos/TablaResponsablesInstalaciones';
const { useEffect, useRef } = React;
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import ModalEnviadoCorrectamente from '../../App/ModalEnviadoCorrectamente';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function FormularioFC36BeneficiarioComponent(props) {
    const dispatch = useDispatch()

    var fechaHoy = moment().format('YYYY-MM-DD');

    let fc_36 = useSelector(store => store.FC_36Solicitud.fc_36)
    const fc_36Ref = useRef(fc_36)

    const [valores, setValores] = useStateIfMounted({})
    var fechaResta = moment().subtract(18, "y");
    var fechaParaMayorEdad = fechaResta.format('YYYY-MM-DD')
    //const valoresInicialesRef = useRef(valores)
    let fc_36AnexoUnidadProduccion = useSelector(store => store.FC_36Solicitud.anexoUnidadProduccion)
    let fc_36AnexoUnidadEnvasado = useSelector(store => store.FC_36Solicitud.anexoUnidadEnvasado)
    let fc_36AnexoUnidadAlmacen = useSelector(store => store.FC_36Solicitud.anexoUnidadAlmacen)
    let fc_36AnexoUnidadProduccionBaja = useSelector(store => store.FC_36Solicitud.anexoUnidadProduccionBaja)
    let fc_36AnexoUnidadEnvasadoBaja = useSelector(store => store.FC_36Solicitud.anexoUnidadEnvasadoBaja)
    let fc_36AnexoUnidadAlmacenBaja = useSelector(store => store.FC_36Solicitud.anexoUnidadAlmacenBaja)
    let fc_36AnexoMarcas = useSelector(store => store.FC_36Solicitud.anexoMarcas)
    let fc_36AnexoMarcasBaja = useSelector(store => store.FC_36Solicitud.anexoMarcasBaja)
    let fc_36AnexoContactos = useSelector(store => store.FC_36Solicitud.anexoContactos)
    let fc_36AnexoContactosBaja = useSelector(store => store.FC_36Solicitud.anexoContactosBaja)
    let fc_36AnexoRepresentantes = useSelector(store => store.FC_36Solicitud.anexoRepresentantes)
    let fc_36AnexoRepresentantesBaja = useSelector(store => store.FC_36Solicitud.anexoRepresentantesBaja)
    const currentUser = useSelector(store => store.Usuario.data)
    const estadosApi = useSelector(store => store.CopomexApi.estados)
    const municipiosApi = useSelector(store => store.CopomexApi.municipios)
    const codigosPostalesApi = useSelector(store => store.CopomexApi.codigosPostales)
    const coloniasApi = useSelector(store => store.CopomexApi.colonias)
    const localidadesApi = useSelector(store => store.CopomexApi.localidades)
    const callesApi = useSelector(store => store.CopomexApi.calles)

    let fc_36Map = useSelector(store => store.FC_36Solicitud.fc_36Map)
    let anexoContactosMap = useSelector(store => store.FC_36Solicitud.anexoContactosMap)
    let anexoRepresentantesMap = useSelector(store => store.FC_36Solicitud.anexoRepresentantesMap)
    let anexoArchivosRepresentantesMap = useSelector(store => store.FC_36Solicitud.anexoArchivosRepresentantesMap)
    let anexoPersonaAutorizadaMap = useSelector(store => store.FC_36Solicitud.anexoPersonaAutorizadaMap)
    let anexoArchivosPersonaAutorizadaMap = useSelector(store => store.FC_36Solicitud.anexoArchivosPersonaAutorizadaMap)
    let anexoDomicilioFiscalMap = useSelector(store => store.FC_36Solicitud.anexoDomicilioFiscalMap)
    let anexoArchivosDomicilioFiscalMap = useSelector(store => store.FC_36Solicitud.anexoArchivosDomicilioFiscalMap)
    let anexoPrediosMap = useSelector(store => store.FC_36Solicitud.anexoPrediosMap)
    let anexoArchivosPrediosMap = useSelector(store => store.FC_36Solicitud.anexoArchivosPrediosMap)
    let anexoViverosMap = useSelector(store => store.FC_36Solicitud.anexoViverosMap)
    let anexoArchivosViverosMap = useSelector(store => store.FC_36Solicitud.anexoArchivosViverosMap)
    let anexoMarcasMap = useSelector(store => store.FC_36Solicitud.anexoMarcasMap)
    let anexoArchivosMarcasMap = useSelector(store => store.FC_36Solicitud.anexoArchivosMarcasMap)
    let anexoMarcasBebidaMap = useSelector(store => store.FC_36Solicitud.anexoMarcasBebidaMap)
    let anexoArchivosMarcasBebidaMap = useSelector(store => store.FC_36Solicitud.anexoArchivosMarcasBebidaMap)
    let anexoInstalacionesMap = useSelector(store => store.FC_36Solicitud.anexoInstalacionesMap)
    let anexoArchivosInstalacionesMap = useSelector(store => store.FC_36Solicitud.anexoArchivosInstalacionesMap)
    let anexoResponsablesInstalacionesMap = useSelector(store => store.FC_36Solicitud.anexoResponsablesInstalacionesMap)
    let anexoArchivosResponsablesInstalacionesMap = useSelector(store => store.FC_36Solicitud.anexoArchivosResponsablesInstalacionesMap)
    let anexoResponsablesInstMap = useSelector(store => store.FC_36Solicitud.anexoResponsablesInstMap)
    let dataLogin = useSelector(store => store.FC_36Solicitud.datosLogin)
    let dataCliente = useSelector(store => store.FC_36Solicitud.cliente)
    const [opcionFileInstalacion, setOpcionFileInstalacion] = React.useState([])

    const [envioCorrecto, setEnvioCorrecto] = React.useState(false)
    const [folio, setFolio] = React.useState('')
    let mediosContactoRegistrados = useSelector(store => store.FC_36Solicitud.mediosContactoRelacionada)
    let mediosContactoDetalle = useSelector(store => store.FC_36Solicitud.mediosContactoDetalle)

    const noActualizarBorrador = useRef(true)



    React.useEffect(() => {
        let data = dispatch(ObtenerClientePorLogin36({ idlogin: usuario.data.user[0].id }))
    }, [])

    const handleSaveFC_36State = () => {
        /*if (fechadenacimiento !== 'Invalid date' && fechadenacimiento !== undefined) {
            fechadenacimiento = new Date(fechadenacimiento).toISOString()
        }
        numerohijos = Number(numerohijos)*/
        let idUsuario = currentUser.user[0].id
        if (data?.idfc36_solicitudactualizacion) {
            dispatch(setCambiosFC_36SolicitudBorrador({ fc_36: fc_36.current }))
        } else {
            const { ...valoresAGuardar } = valores.current
            dispatch(setCambiosFC_36SolicitudNueva({ valores: valoresAGuardar }))
        }

    }
    let [certificacionsi, setcertificacionsi] = useStateIfMounted(false)
    let [certificacionno, setcertificacionno] = useStateIfMounted(false)
    let [empresacertificadora, setempresacertificadora] = useStateIfMounted('')

    const [cambiorazon, setcambiorazon] = useState(false)
    const [actualizacioncadena, setactualizacioncadena] = useState(false)
    const [actualizacionmarca, setactualizacionmarca] = useState(false)
    const [actualizaciondomicilio, setactualizaciondomicilio] = useState(false)
    const [cambioresponsable, setcambioresponsable] = useState(false)
    const [cambiorepresentante, setcambiorepresentante] = useState(false)
    const [actualizarmedioscontacto, setactualizarmedioscontacto] = useState(false)
    const [cambioresponsableinst, setcambioresponsableinst] = useState(false)
    const [actualizarmarca, setActualizarMarca] = useState(false)
    const [actualizarinstalaciones, setActualizarInstalaciones] = useState(false)
    const [actualizarprediosviveros, setActualizarPrediosViveros] = useState(false)

    const [viveristaalta, setviveristaalta] = useStateIfMounted(false)
    const [viveristabaja, setviveristabaja] = useStateIfMounted(false)
    const [productormagueyalta, setproductormagueyalta] = useStateIfMounted(false)
    const [productormagueybaja, setproductormagueybaja] = useStateIfMounted(false)
    const [productormezcalalta, setproductormezcalalta] = useStateIfMounted(false)
    const [productormezcalbaja, setproductormezcalbaja] = useStateIfMounted(false)
    const [envasadoralta, setenvasadoralta] = useStateIfMounted(false)
    const [envasadorbaja, setenvasadorbaja] = useStateIfMounted(false)
    const [comercializadormezcalalta, setcomercializadormezcalalta] = useStateIfMounted(false)
    const [comercializadormezcalbaja, setcomercializadormezcalbaja] = useStateIfMounted(false)
    const [comercializadorbebidasalta, setcomercializadorbebidasalta] = useStateIfMounted(false)
    const [comercializadorbebidasbaja, setcomercializadorbebidasbaja] = useStateIfMounted(false)

    const guardarActividadesEmpresa = async () => {
        const data = {
            productormezcal: dataCliente.productormezcal,
            envasador: dataCliente.envasador,
            comercializadormezcal: dataCliente.comercializadormezcal,
            comercializadorbebidasconmezcal: dataCliente.comercializadorbebidasconmezcal,
            productormezcalaltabaja: productormezcalaltabaja,
            envasadoraltabaja: envasadoraltabaja,
            comercializadormezcalaltabaja: comercializadormezcalaltabaja,
            comercializadorbebidasaltabaja: comercializadorbebidasaltabaja
        }
        await dispatch(agregarFC_36ActividadesEmpresa(data))
    }
    const guardarDatos = async (valores) => {
        await dispatch(agregarFC_36(valores))
    }

    let [terminosYCondiciones, setTerminosYCondiciones] = useStateIfMounted(false)
    React.useEffect(() => {
        if (props.history.location.state) {
            setTerminosYCondiciones(props.history.location.state.terminosYCondiciones)
        }
    }, [props.history.location.state])
    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const [paginas, setPaginas] = useStateIfMounted([1, 2])
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Datos generales', 'Documentación'])
    const paginaActiva = useSelector(store => store.FC_36Solicitud.paginaActiva)
    const paginaSiguiente = async (valores) => {
        const result = await validation(valores)
        if (JSON.stringify(result) !== '{}') {
            settexto('')
            setvalidacion(true)
        } else {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            dispatch(actualizarFC_36PaginaActiva(paginaActiva + 1))
        }
    }
    const paginaAnterior = async () => {
        dispatch(actualizarFC_36PaginaActiva(paginaActiva - 1))
    }
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }

    const [viveristaaltabaja, setviveristaaltabaja] = useStateIfMounted(false)
    const [productormagueyaltabaja, setproductormagueyaltabaja] = useStateIfMounted(false)

    const [productormezcalaltabaja, setproductormezcalaltabaja] = useStateIfMounted(false)
    const [envasadoraltabaja, setenvasadoraltabaja] = useStateIfMounted(false)
    const [comercializadormezcalaltabaja, setcomercializadormezcalaltabaja] = useStateIfMounted(false)

    const [comercializadorbebidasaltabaja, setcomercializadorbebidasaltabaja] = useStateIfMounted(false)

    React.useEffect(() => {
        let totalDePaginas = 2
        const nuevosApartados = ['Datos generales']

        if ((actualizacioncadena && ((fc_36.productormaguey && productormagueyaltabaja) || (fc_36.viverista && viveristaaltabaja))) || (actualizarprediosviveros && !fc_36.cambiorazon) ||
            (fc_36.cambiorazon && fc_36.productormaguey) || (fc_36.cambiorazon && fc_36.viverista)) {
            totalDePaginas++
            let nombreApartado = 'Predios/Viveros'
            nuevosApartados.push(nombreApartado)
        }
        if ((actualizacioncadena && ((!dataCliente.comercializadorbebidasmezcal && comercializadorbebidasaltabaja) || (!dataCliente.comercializadormezcal && comercializadormezcalaltabaja))) ||
            (actualizarmarca && !fc_36.cambiorazon) || (fc_36.cambiorazon && fc_36.comercializadorbebidas) || (fc_36.cambiorazon && fc_36.comercializadormezcal)) {
            totalDePaginas++
            let nombreApartado = 'Marcas'
            nuevosApartados.push(nombreApartado)
        }
        if (fc_36.actualizacioninstalaciones || fc_36.cambiorazon || (fc_36.actualizacioncadena && ((!fc_36.productormezcal && productormezcalaltabaja) ||
            (!fc_36.envasador && envasadoraltabaja) || (!fc_36.comercializadormezcal && comercializadormezcalaltabaja) ||
            (!fc_36.comercializadorbebidas && comercializadorbebidasaltabaja))) ||
            (fc_36.actualizacioncadena && ((fc_36.productormezcal && productormezcalaltabaja) ||
                (fc_36.envasador && envasadoraltabaja) || (fc_36.comercializadormezcal && comercializadormezcalaltabaja) ||
                (fc_36.comercializadorbebidas && comercializadorbebidasaltabaja)))) {
            totalDePaginas++
            let nombreApartado = 'Instalaciones'
            nuevosApartados.push(nombreApartado)
        }
        if (cambioresponsableinst) {
            totalDePaginas++
            let nombreApartado = 'Responsables de Instalaciones'
            nuevosApartados.push(nombreApartado)
        }
        nuevosApartados.push('Documentación')
        let nuevasPaginas = []
        for (let index = 1; index <= totalDePaginas; index++) {
            nuevasPaginas.push(index)
        }
        setPaginas(nuevasPaginas)
        setNombresParaPaginas(nuevosApartados)
    }, [actualizacionmarca, actualizaciondomicilio, cambioresponsable, cambiorepresentante, actualizarmedioscontacto,
        viveristaalta, viveristabaja, productormagueyalta, productormagueybaja, comercializadormezcalalta,
        comercializadormezcalbaja, comercializadorbebidasalta, comercializadorbebidasbaja, productormezcalalta,
        productormezcalbaja, envasadoralta, envasadorbaja, cambioresponsableinst, actualizarmarca, actualizarinstalaciones,
        actualizarprediosviveros, viveristaaltabaja, productormagueyaltabaja, productormezcalaltabaja, envasadoraltabaja,
        comercializadormezcalaltabaja, comercializadorbebidasaltabaja, fc_36])

    const modoEdicionBorrador = useSelector(store => store.FC_36Solicitud.modoEdicionBorrador)
    const modoCorreccion = useSelector(store => store.FC_36Solicitud.modoCorreccion)
    let data = useSelector(store => store.FC_36Solicitud.data)
    let dataDetalle = useSelector(store => store.FC_36Solicitud.dataDetalle)
    const usuario = useSelector(store => store.Usuario)
    const idUsuario = usuario.data.user[0].id

    const [unidadesDeProduccionParaDarDeBaja, setUnidadesDeProducccionParaDarDeBaja] = useState([])

    const cambioUnidadProduccionParaBaja = (data) => {
        const unidadBaja = unidadesDeProduccionParaDarDeBaja.filter(field => field.id === data.id)
        unidadBaja[0][data.campo] = data.valor
        setUnidadesDeProducccionParaDarDeBaja([...unidadesDeProduccionParaDarDeBaja]);
    }

    const [unidadesDeEnvasadoParaDarDeBaja, setUnidadesDeEnvasadoParaDarDeBaja] = useState([])

    const cambioUnidadEnvasadoParaBaja = (data) => {
        const unidadBaja = unidadesDeEnvasadoParaDarDeBaja.filter(field => field.id === data.id)
        unidadBaja[0][data.campo] = data.valor
        setUnidadesDeEnvasadoParaDarDeBaja([...unidadesDeEnvasadoParaDarDeBaja]);
    }

    const [unidadesDeAlmacenParaDarDeBaja, setUnidadesDeAlmacenParaDarDeBaja] = useState([])

    const cambioUnidadAlmacenParaBaja = (data) => {
        const unidadBaja = unidadesDeAlmacenParaDarDeBaja.filter(field => field.id === data.id)
        unidadBaja[0][data.campo] = data.valor
        setUnidadesDeAlmacenParaDarDeBaja([...unidadesDeAlmacenParaDarDeBaja]);
    }

    //Informacion del solicitante
    const [nocliente, setnocliente] = useState(7)
    const [certificadonomproductor, setcertificadonomproductor] = useStateIfMounted(false)
    const [certificadonomenvasador, setcertificadonomenvasador] = useStateIfMounted(false)
    const [certificadonomcomercializador, setcertificadonomcomercializador] = useStateIfMounted(false)
    const [nombrerazonsocial, setnombrerazonsocial] = useStateIfMounted('')
    const [rfc, setrfc] = useStateIfMounted('')
    const [numeroexterior, setnumeroexterior] = useStateIfMounted('')
    const [numerointerior, setnumerointerior] = useStateIfMounted('')

    const [idfc36_solicitudactualizacion, setidfc36_solicitudactualizacion] = useStateIfMounted(0)
    const [idlogin, setidlogin] = useStateIfMounted(idUsuario)

    const store = useSelector(store => store)

    const handleResetAllPropertys = () => {
        handleCloseModal()
    }

    React.useEffect(() => {
        if (JSON.stringify({}) != JSON.stringify(dataDetalle) && JSON.stringify([]) !== JSON.stringify(dataDetalle)) {
            dispatch(agregarFC_36(dataDetalle))
            /*data = dataDetalle
            fc_36 = dataDetalle*/
        }
        if (!(JSON.stringify({}) === JSON.stringify(data))) {
            fc_36 = data
        }
        if (!(JSON.stringify({}) == JSON.stringify(fc_36))) {
            if (fc_36.actualizarmedioscontacto) setactualizarmedioscontacto(fc_36.actualizarmedioscontacto)
            if (fc_36.cambioresponsable) setcambioresponsable(fc_36.cambioresponsable)
            if (fc_36.cambiorepresentante) setcambiorepresentante(fc_36.cambiorepresentante)
            if (fc_36.actualizaciondomicilio) setactualizaciondomicilio(fc_36.actualizaciondomicilio)
            if (fc_36.actualizarmarcas) setActualizarMarca(fc_36.actualizarmarcas)
            if (fc_36.actualizacioninstalaciones) setActualizarInstalaciones(fc_36.actualizacioninstalaciones)
            if (fc_36.actualizacionprediosviveros) setActualizarPrediosViveros(fc_36.actualizacionprediosviveros)
            if (fc_36.actualizacioncadena) {
                setactualizacioncadena(fc_36.actualizacioncadena)
                if (fc_36.viverista) setviveristaalta(fc_36.viverista)
                if (fc_36.productormaguey) setproductormagueyalta(fc_36.productormaguey)
                if (fc_36.productormezcal) setproductormezcalalta(fc_36.productormezcal)
                if (fc_36.envasador) setenvasadoralta(fc_36.envasador)
                if (fc_36.comercializadormezcal) setcomercializadormezcalalta(fc_36.comercializadormezcal)
                if (fc_36.comercializadormezcal) setactualizacionmarca(fc_36.comercializadormezcal)
                if (fc_36.comercializadorbebidas) setcomercializadorbebidasalta(fc_36.comercializadorbebidas)

                if (fc_36.viveristaaltabaja) setviveristaaltabaja(fc_36.viveristaaltabaja)
                if (fc_36.productormagueyaltabaja) setproductormagueyaltabaja(fc_36.productormagueyaltabaja)
                if (fc_36.productormezcalaltabaja) setproductormezcalaltabaja(fc_36.productormezcalaltabaja)
                if (fc_36.envasadoraltabaja) setenvasadoraltabaja(fc_36.envasadoraltabaja)
                if (fc_36.comercializadormezcalaltabaja) setcomercializadormezcalaltabaja(fc_36.comercializadormezcalaltabaja)
                if (fc_36.comercializadorbebidasaltabaja) setcomercializadorbebidasaltabaja(fc_36.comercializadorbebidasaltabaja)

            } else {
                setviveristaalta(false)
                setproductormagueyalta(false)
                setproductormezcalalta(false)
                setenvasadoralta(false)
                setcomercializadormezcalalta(false)
                setactualizacionmarca(false)
                setcomercializadorbebidasalta(false)
            }

            if (fc_36.cambioresponsableinst) setcambioresponsableinst(fc_36.cambioresponsableinst)
            if (fc_36.cambiorazon) setcambiorazon(fc_36.cambiorazon)
            setValores(fc_36)
        }
    }, [fc_36, data, dataDetalle])

    const [functionResetForm, setFunctionResetForm] = React.useState()
    const [functionSubmitForm, setFunctionSubmitForm] = React.useState()


    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const [dataModal, setDataModal] = React.useState('')

    const handleOpenModal = (data) => {
        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setOpenModal(true)
        setDataModal(data.data)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
        setDataModal('')
    }
    const modalComponent = () => {
        return (
            <div>
                <Modal open={openModal} onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>{titleModal}</center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <p className={`${estilos.bodyModal}`}>{bodyModal}</p> <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-dark' onClick={() => {
                                switch (accion) {
                                    case 'guardarBorrador':
                                        guardarBorrador(dataModal)
                                        break;
                                    case 'actualizarBorrador':
                                        actualizarBorrador(dataModal)
                                        break;
                                    case 'enviarSolicitudBorradorFC_36':
                                        activarBotonEnviarBorrador()
                                        functionSubmitForm.function()
                                        break;
                                    case 'enviarSolicitudFC_36':
                                        activarBotonEnviarForm()
                                        functionSubmitForm.function()
                                        break;
                                    case 'enviarCorreccion':
                                        activarBotonEnviarCorreciones()
                                        functionSubmitForm.function()
                                        break;
                                    default:
                                        break;
                                }
                            }
                            }>CONTINUAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }
    const [botonEnviarBorrador, setBotonEnviarBorrador] = React.useState(false)
    const [botonEnviarRegistro, setBotonEnviarRegistro] = React.useState(false)
    const [botonEnviarCorrecciones, setBotonEnviarCorrecciones] = React.useState(false)
    const activarBotonEnviarCorreciones = () => {
        setBotonEnviarCorrecciones(true)
    }

    const activarBotonEnviarForm = () => {
        setBotonEnviarRegistro(true)
    }
    const activarBotonEnviarBorrador = () => {
        setBotonEnviarBorrador(true)
    }
    const botonGuardarComoBorrador = async (valores) => {
        if (modoEdicionBorrador) {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de actualizar este borrador de solicitud.
                Los archivos de la sección final no se guardarán, puesto que es un borrador del formulario.`,
                accion: 'actualizarBorrador',
                data: valores
            })
        } else {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de guardar esta solicitud en su apartado de borradores.
                Los archivos de la sección final no se guardarán puesto que es un borrador del formulario.`,
                accion: 'guardarBorrador',
                data: valores
            })
        }
    }
    const botonEnviarSolicitudBorradorFC_36 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atención al cliente.`,
            accion: 'enviarSolicitudBorradorFC_36'
        })
    }

    const botonReiniciarFormato = () => {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de reiniciar el formato, esta acción eliminará toda la información
                y no se podrá revertir.`,
            accion: 'reiniciarFormato'
        })
    }
    const botonEnviarSolicitudFC_36 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atención al cliente.`,
            accion: 'enviarSolicitudFC_36'
        })
    }
    const botonEnviarCorreccionesFC_36 = async () => {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de enviar las correcciones al personal de atención al cliente, 
            ya no podrá seguir corrigiendo esta solicitud.`,
            accion: 'enviarCorreccion'
        })
    }

    const guardarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let fechanacimiento = ''
        if (valores.fechadenacimiento) fechanacimiento = new Date(valores.fechadenacimiento).toISOString()
        else fechanacimiento = null

        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))

        var añoFolio = moment().format('YY');
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 99999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio

        const solicitud = {
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, nombrerazonsocial: dataCliente.nombrerazonsocial,
            actualizarmedioscontacto: valores.actualizarmedioscontacto, cambiorazon: valores.cambiorazon, actualizacioncadena: valores.actualizacioncadena,
            actualizaciondomicilio: valores.actualizaciondomicilio, cambioresponsable: valores.cambioresponsable,
            cambiorepresentante: valores.cambiorepresentante, cambioresponsableinst: valores.cambioresponsableinst, actualizarmarcas: valores.actualizarmarcas,
            viverista: valores.viverista, productormaguey: valores.productormaguey, productormezcal: valores.productormezcal,
            envasador: valores.envasador, comercializadormezcal: valores.comercializadormezcal,
            comercializadorbebidas: valores.comercializadorbebidas, actualizacionprediosviveros: valores.actualizacionprediosviveros,
            actualizacioninstalaciones: valores.actualizacioninstalaciones,

            viveristaaltabaja: viveristaaltabaja, productormagueyaltabaja: productormagueyaltabaja,
            productormezcalaltabaja: productormezcalaltabaja, envasadoraltabaja: envasadoraltabaja,
            comercializadormezcalaltabaja: comercializadormezcalaltabaja, comercializadorbebidasaltabaja: comercializadorbebidasaltabaja,

            medioscontactosi: valores.medioscontactosi, medioscontactono: valores.medioscontactono,
            repesentantelegalsi: valores.repesentantelegalsi, repesentantelegalno: valores.repesentantelegalno,
            personaautorizadasi: valores.personaautorizadasi, personaautorizadano: valores.personaautorizadano,
            domiciliofiscalsi: valores.domiciliofiscalsi, domiciliofiscalno: valores.domiciliofiscalno,
            actualizacionprediossi: valores.actualizacionprediossi, actualizacionprediosno: valores.actualizacionprediosno,
            actualizacionviverossi: valores.actualizacionviverossi, actualizacionviverosno: valores.actualizacionviverosno,
            actualizacioninstalacionsi: valores.actualizacioninstalacionsi, actualizacioninstalacionno: valores.actualizacioninstalacionno,

            fechadenacimiento: fechanacimiento, sexo: valores.sexo, estadocivil: valores.estadocivil,
            escolaridad: valores.escolaridad, discapacidadno: valores.discapacidadno, discapacidadsi: valores.discapacidadsi,
            tipodiscapacidad: valores.tipodiscapacidad, lenguaindijenasi: valores.lenguaindijenasi, lenguaindijenano: valores.lenguaindijenano,
            tipoLengua: valores.tipoLengua, ocupacion: valores.ocupacion, numerohijos: valores.numerohijos,
            tipoempresa: valores.tipoempresa, rfc: valores.rfc, actualizacionnombrerazon: valores.actualizacionnombrerazon,
            certificacionsi: valores.certificacionsi, certificacionno: valores.certificacionno,
            empresacertificadora: valores.empresacertificadora, numerohombres: valores.numerohombres.toString(),
            numeromujeres: valores.numeromujeres.toString(), numerodiscapacitados: valores.numerodiscapacitados.toString(),
            numerobase: valores.numerobase.toString(), numeroeventuales: valores.numeroeventuales.toString(),
            idestatusdesolicitudes: 1, idlogin: idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, folio: consFolio,
        }

        let objetoCompleto = {
            solicitud: solicitud, mediosContacto: mediosContacto,
            responsablesLegales: responsablesLegales, personaAutorizada: personaAutorizada,
            domiciliosFiscales: domicilio, predios: predios, viveros: viveros, instalaciones: anexoInstalaciones,
            responsableInst: responsableInst, marcas: marcas, marcasBebidas: marcasBebidas
        }
        const resultado = await dispatch(registrarSolicitudFC_36Accion(objetoCompleto))
        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_36())
            await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
            window.location.reload(true)
        }
    }
    const actualizarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let fechanacimiento = ''
        if (valores.fechadenacimiento) fechanacimiento = new Date(valores.fechadenacimiento).toISOString()
        else fechanacimiento = null
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio
        const solicitud = {idfc36_solicitudactualizacion:fc_36?.idfc36_solicitudactualizacion,
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, nombrerazonsocial: dataCliente.nombrerazonsocial,
            actualizarmedioscontacto: valores.actualizarmedioscontacto, cambiorazon: valores.cambiorazon, actualizacioncadena: valores.actualizacioncadena,
            actualizaciondomicilio: valores.actualizaciondomicilio, cambioresponsable: valores.cambioresponsable,
            cambiorepresentante: valores.cambiorepresentante, cambioresponsableinst: valores.cambioresponsableinst, actualizarmarcas: valores.actualizarmarcas,
            viverista: valores.viverista, productormaguey: valores.productormaguey, productormezcal: valores.productormezcal,
            envasador: valores.envasador, comercializadormezcal: valores.comercializadormezcal,
            comercializadorbebidas: valores.comercializadorbebidas, actualizacionprediosviveros: valores.actualizacionprediosviveros,
            actualizacioninstalaciones: valores.actualizacioninstalaciones,

            viveristaaltabaja: viveristaaltabaja, productormagueyaltabaja: productormagueyaltabaja,
            productormezcalaltabaja: productormezcalaltabaja, envasadoraltabaja: envasadoraltabaja,
            comercializadormezcalaltabaja: comercializadormezcalaltabaja, comercializadorbebidasaltabaja: comercializadorbebidasaltabaja,

            medioscontactosi: valores.medioscontactosi, medioscontactono: valores.medioscontactono,
            repesentantelegalsi: valores.repesentantelegalsi, repesentantelegalno: valores.repesentantelegalno,
            personaautorizadasi: valores.personaautorizadasi, personaautorizadano: valores.personaautorizadano,
            domiciliofiscalsi: valores.domiciliofiscalsi, domiciliofiscalno: valores.domiciliofiscalno,
            actualizacionprediossi: valores.actualizacionprediossi, actualizacionprediosno: valores.actualizacionprediosno,
            actualizacionviverossi: valores.actualizacionviverossi, actualizacionviverosno: valores.actualizacionviverosno,
            actualizacioninstalacionsi: valores.actualizacioninstalacionsi, actualizacioninstalacionno: valores.actualizacioninstalacionno,

            fechadenacimiento: fechanacimiento, sexo: valores.sexo, estadocivil: valores.estadocivil,
            escolaridad: valores.escolaridad, discapacidadno: valores.discapacidadno, discapacidadsi: valores.discapacidadsi,
            tipodiscapacidad: valores.tipodiscapacidad, lenguaindijenasi: valores.lenguaindijenasi, lenguaindijenano: valores.lenguaindijenano,
            tipoLengua: valores.tipoLengua, ocupacion: valores.ocupacion, numerohijos: valores.numerohijos,
            tipoempresa: valores.tipoempresa, rfc: valores.rfc, actualizacionnombrerazon: valores.actualizacionnombrerazon,
            certificacionsi: valores.certificacionsi, certificacionno: valores.certificacionno,
            empresacertificadora: valores.empresacertificadora, numerohombres: valores.numerohombres.toString(),
            numeromujeres: valores.numeromujeres.toString(), numerodiscapacitados: valores.numerodiscapacitados.toString(),
            numerobase: valores.numerobase.toString(), numeroeventuales: valores.numeroeventuales.toString(),
            idestatusdesolicitudes: 1
        }

        let objetoCompleto = {
            solicitud: solicitud, mediosContacto: mediosContacto,
            responsablesLegales: responsablesLegales, personaAutorizada: personaAutorizada,
            domiciliosFiscales: domicilio, predios: predios, viveros: viveros, instalaciones: anexoInstalaciones,
            responsableInst: responsableInst, marcas: marcas, marcasBebidas: marcasBebidas
        }
        const resultado = await dispatch(actualizarFC_36Solicitud(objetoCompleto))

        await dispatch(actualizarLoadingApp_false())
        await dispatch(resetDataFC_36())
        await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
        props.history.push('/solicitudes')
    }

    const enviarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let fechanacimiento = ''
        if (valores.fechadenacimiento) fechanacimiento = new Date(valores.fechadenacimiento).toISOString()
        else fechanacimiento = null

        let estatus = 7
        if (valores.actualizarmedioscontacto) estatus = 2

        let bajaPersona = personaAutorizada.filter(anexo => anexo.baja == true)
        let altaPersona = personaAutorizada.filter(anexo => anexo.alta == true)
        if (bajaPersona.length > 0 && altaPersona.length > 0) estatus = 7
        else if (bajaPersona.length > 0 && altaPersona.length == 0) estatus = 2
        else if (bajaPersona.length == 0 && altaPersona.length > 0) estatus = 7


        let bajaRepresentante = responsablesLegales.filter(anexo => anexo.baja == true)
        let altaRepresentante = responsablesLegales.filter(anexo => anexo.alta == true)
        if (bajaRepresentante.length > 0 && altaRepresentante.length > 0) estatus = 7
        else if (bajaRepresentante.length > 0 && altaRepresentante.length == 0) estatus = 2
        else if (bajaRepresentante.length == 0 && altaRepresentante.length > 0) estatus = 7

        let bajaDomicilio = domicilio.filter(anexo => anexo.baja == true)
        let altaDomicilio = domicilio.filter(anexo => anexo.alta == true)
        if (bajaDomicilio.length > 0 && altaDomicilio.length > 0) estatus = 7
        else if (bajaDomicilio.length > 0 && altaDomicilio.length == 0) estatus = 2
        else if (bajaDomicilio.length == 0 && altaDomicilio.length > 0) estatus = 7

        let bajaMarcas = marcas.filter(anexo => anexo.baja == true)
        let altaMarcas = marcas.filter(anexo => anexo.alta == true)
        if (bajaMarcas.length > 0 && altaMarcas.length > 0) estatus = 7
        else if (bajaMarcas.length > 0 && altaMarcas.length == 0) estatus = 2
        else if (bajaMarcas.length == 0 && altaMarcas.length > 0) estatus = 7

        let bajaMarcasBebidas = marcasBebidas.filter(anexo => anexo.baja == true)
        let altaMarcasBebidas = marcasBebidas.filter(anexo => anexo.alta == true)
        if (bajaMarcasBebidas.length > 0 && altaMarcasBebidas.length > 0) estatus = 7
        else if (bajaMarcasBebidas.length > 0 && altaMarcasBebidas.length == 0) estatus = 2
        else if (bajaMarcasBebidas.length == 0 && altaMarcasBebidas.length > 0) estatus = 7

        let bajaResponsableInst = responsableInst.filter(anexo => anexo.baja == true)
        let altaResponsableInst = responsableInst.filter(anexo => anexo.alta == true)
        if (bajaResponsableInst.length > 0 && altaResponsableInst.length > 0) estatus = 7
        else if (bajaResponsableInst.length > 0 && altaResponsableInst.length == 0) estatus = 2
        else if (bajaResponsableInst.length == 0 && altaResponsableInst.length > 0) estatus = 7

        if (valores.actualizacionprediosviveros) {
            let bajaPredios = predios.filter(anexo => anexo.baja == true)
            let altaPredios = predios.filter(anexo => anexo.alta == true)
            if (bajaPredios.length > 0 && altaPredios.length > 0) estatus = 7
            else if (bajaPredios.length > 0 && altaPredios.length == 0) estatus = 2
            else if (bajaPredios.length == 0 && altaPredios.length > 0) estatus = 7

            let bajaViveros = viveros.filter(anexo => anexo.baja == true)
            let altaViveros = viveros.filter(anexo => anexo.alta == true)
            if (bajaViveros.length > 0 && altaViveros.length > 0) estatus = 7
            else if (bajaViveros.length > 0 && altaViveros.length == 0) estatus = 2
            else if (bajaViveros.length == 0 && altaViveros.length > 0) estatus = 7
        }

        if (valores.actualizacioninstalaciones) {
            let bajaAnexos = anexoInstalaciones.filter(anexo => anexo.data.baja == true)
            let altaAnexos = anexoInstalaciones.filter(anexo => anexo.data.alta == true)
            if (bajaAnexos.length > 0 && altaAnexos.length > 0) estatus = 7
            else if (bajaAnexos.length > 0 && altaAnexos.length == 0) estatus = 2
            else if (bajaAnexos.length == 0 && altaAnexos.length > 0) estatus = 7
        }

        if ((valores.actualizacioncadena && ((dataCliente.productormaguey && productormagueyaltabaja) ||
            (dataCliente.viverista && viveristaaltabaja) || (fc_36.comercializadorbebidasaltabaja && fc_36.comercializadorbebidas) ||
            (dataCliente.comercializadormezcal && comercializadormezcalaltabaja) || (dataCliente.comercializadorbebidas && comercializadorbebidasaltabaja) ||
            (!fc_36.envasador && envasadoraltabaja && (marcas.length == 0 && marcasBebidas.length == 0)) ||
            (!fc_36.productormezcal && productormezcalaltabaja && (marcas.length == 0 && marcasBebidas.length == 0)))
            //&& (!envasadoraltabaja && !productormezcalaltabaja)
        ) && (altaMarcasBebidas.length == 0 && altaMarcas.length == 0)) estatus = 2
        else if (valores.actualizacioncadena) estatus = 7

        if (valores.actualizacioncadena && (viveros.filter(anexo => anexo.alta == true).length > 0 || predios.filter(anexo => anexo.alta == true).length > 0 ||
            marcas.filter(anexo => anexo.alta == true).length > 0 || marcasBebidas.filter(anexo => anexo.alta == true).length > 0)) estatus = 7
        if (valores.cambiorazon) estatus = 7

        const solicitud = {idfc36_solicitudactualizacion:fc_36?.idfc36_solicitudactualizacion,
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, nombrerazonsocial: dataCliente.nombrerazonsocial,
            actualizarmedioscontacto: valores.actualizarmedioscontacto, cambiorazon: valores.cambiorazon, actualizacioncadena: valores.actualizacioncadena,
            actualizaciondomicilio: valores.actualizaciondomicilio, cambioresponsable: valores.cambioresponsable,
            cambiorepresentante: valores.cambiorepresentante, cambioresponsableinst: valores.cambioresponsableinst, actualizarmarcas: valores.actualizarmarcas,
            viverista: valores.viverista, productormaguey: valores.productormaguey, productormezcal: valores.productormezcal,
            envasador: valores.envasador, comercializadormezcal: valores.comercializadormezcal,
            comercializadorbebidas: valores.comercializadorbebidas, actualizacionprediosviveros: valores.actualizacionprediosviveros,
            actualizacioninstalaciones: valores.actualizacioninstalaciones,

            viveristaaltabaja: viveristaaltabaja, productormagueyaltabaja: productormagueyaltabaja,
            productormezcalaltabaja: productormezcalaltabaja, envasadoraltabaja: envasadoraltabaja,
            comercializadormezcalaltabaja: comercializadormezcalaltabaja, comercializadorbebidasaltabaja: comercializadorbebidasaltabaja,

            medioscontactosi: valores.medioscontactosi, medioscontactono: valores.medioscontactono,
            repesentantelegalsi: valores.repesentantelegalsi, repesentantelegalno: valores.repesentantelegalno,
            personaautorizadasi: valores.personaautorizadasi, personaautorizadano: valores.personaautorizadano,
            domiciliofiscalsi: valores.domiciliofiscalsi, domiciliofiscalno: valores.domiciliofiscalno,
            actualizacionprediossi: valores.actualizacionprediossi, actualizacionprediosno: valores.actualizacionprediosno,
            actualizacionviverossi: valores.actualizacionviverossi, actualizacionviverosno: valores.actualizacionviverosno,
            actualizacioninstalacionsi: valores.actualizacioninstalacionsi, actualizacioninstalacionno: valores.actualizacioninstalacionno,

            fechadenacimiento: fechanacimiento, sexo: valores.sexo, estadocivil: valores.estadocivil,
            escolaridad: valores.escolaridad, discapacidadno: valores.discapacidadno, discapacidadsi: valores.discapacidadsi,
            tipodiscapacidad: valores.tipodiscapacidad, lenguaindijenasi: valores.lenguaindijenasi, lenguaindijenano: valores.lenguaindijenano,
            tipoLengua: valores.tipoLengua, ocupacion: valores.ocupacion, numerohijos: valores.numerohijos,
            tipoempresa: valores.tipoempresa, rfc: valores.rfc, actualizacionnombrerazon: valores.actualizacionnombrerazon,
            certificacionsi: valores.certificacionsi, certificacionno: valores.certificacionno,
            empresacertificadora: valores.empresacertificadora, numerohombres: valores.numerohombres.toString(),
            numeromujeres: valores.numeromujeres.toString(), numerodiscapacitados: valores.numerodiscapacitados.toString(),
            numerobase: valores.numerobase.toString(), numeroeventuales: valores.numeroeventuales.toString(),
            idestatusdesolicitudes: 7
        }

        let objetoCompleto = {
            solicitud: solicitud, mediosContacto: mediosContacto,
            responsablesLegales: responsablesLegales, personaAutorizada: personaAutorizada,
            domiciliosFiscales: domicilio, predios: predios, viveros: viveros, instalaciones: anexoInstalaciones,
            responsableInst: responsableInst, marcas: marcas, marcasBebidas: marcasBebidas
        }
        const resultado = await dispatch(actualizarFC_36Solicitud(objetoCompleto))
        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            const idSolicitud = data.idfc36_solicitudactualizacion
            const estatusNuevo = 7
            const idCliente = dataCliente.idcliente//null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_36 = 10
            const tabla = tablaFC_36
            await dispatch(actualizarFC_36Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
            ))
            await dispatch(resetDataFC_36())
            functionResetForm.function()
            await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
            window.location.reload(true)
        }
    }
    const botonRegistrarFC_36 = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let fechanacimiento = ''
        if (valores.fechadenacimiento) fechanacimiento = new Date(valores.fechadenacimiento).toISOString()
        else fechanacimiento = null

        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))
        var añoFolio = moment().format('YY');
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 99999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio

        let estatus = 7
        if (valores.actualizarmedioscontacto) estatus = 2

        let bajaPersona = personaAutorizada.filter(anexo => anexo.baja == true)
        let altaPersona = personaAutorizada.filter(anexo => anexo.alta == true)
        if (bajaPersona.length > 0 && altaPersona.length > 0) estatus = 7
        else if (bajaPersona.length > 0 && altaPersona.length == 0) estatus = 2
        else if (bajaPersona.length == 0 && altaPersona.length > 0) estatus = 7


        let bajaRepresentante = responsablesLegales.filter(anexo => anexo.baja == true)
        let altaRepresentante = responsablesLegales.filter(anexo => anexo.alta == true)
        if (bajaRepresentante.length > 0 && altaRepresentante.length > 0) estatus = 7
        else if (bajaRepresentante.length > 0 && altaRepresentante.length == 0) estatus = 2
        else if (bajaRepresentante.length == 0 && altaRepresentante.length > 0) estatus = 7

        let bajaDomicilio = domicilio.filter(anexo => anexo.baja == true)
        let altaDomicilio = domicilio.filter(anexo => anexo.alta == true)
        if (bajaDomicilio.length > 0 && altaDomicilio.length > 0) estatus = 7
        else if (bajaDomicilio.length > 0 && altaDomicilio.length == 0) estatus = 2
        else if (bajaDomicilio.length == 0 && altaDomicilio.length > 0) estatus = 7

        let bajaMarcas = marcas.filter(anexo => anexo.baja == true)
        let altaMarcas = marcas.filter(anexo => anexo.alta == true)
        if (bajaMarcas.length > 0 && altaMarcas.length > 0) estatus = 7
        else if (bajaMarcas.length > 0 && altaMarcas.length == 0) estatus = 2
        else if (bajaMarcas.length == 0 && altaMarcas.length > 0) estatus = 7

        let bajaMarcasBebidas = marcasBebidas.filter(anexo => anexo.baja == true)
        let altaMarcasBebidas = marcasBebidas.filter(anexo => anexo.alta == true)
        if (bajaMarcasBebidas.length > 0 && altaMarcasBebidas.length > 0) estatus = 7
        else if (bajaMarcasBebidas.length > 0 && altaMarcasBebidas.length == 0) estatus = 2
        else if (bajaMarcasBebidas.length == 0 && altaMarcasBebidas.length > 0) estatus = 7

        let bajaResponsableInst = responsableInst.filter(anexo => anexo.baja == true)
        let altaResponsableInst = responsableInst.filter(anexo => anexo.alta == true)
        if (bajaResponsableInst.length > 0 && altaResponsableInst.length > 0) estatus = 7
        else if (bajaResponsableInst.length > 0 && altaResponsableInst.length == 0) estatus = 2
        else if (bajaResponsableInst.length == 0 && altaResponsableInst.length > 0) estatus = 7

        if (valores.actualizacionprediosviveros) {
            let bajaPredios = predios.filter(anexo => anexo.baja == true)
            let altaPredios = predios.filter(anexo => anexo.alta == true)
            if (bajaPredios.length > 0 && altaPredios.length > 0) estatus = 7
            else if (bajaPredios.length > 0 && altaPredios.length == 0) estatus = 2
            else if (bajaPredios.length == 0 && altaPredios.length > 0) estatus = 7

            let bajaViveros = viveros.filter(anexo => anexo.baja == true)
            let altaViveros = viveros.filter(anexo => anexo.alta == true)
            if (bajaViveros.length > 0 && altaViveros.length > 0) estatus = 7
            else if (bajaViveros.length > 0 && altaViveros.length == 0) estatus = 2
            else if (bajaViveros.length == 0 && altaViveros.length > 0) estatus = 7
        }

        if (valores.actualizacioninstalaciones) {
            let bajaAnexos = anexoInstalaciones.filter(anexo => anexo.data.baja == true)
            let altaAnexos = anexoInstalaciones.filter(anexo => anexo.data.alta == true)
            if (bajaAnexos.length > 0 && altaAnexos.length > 0) estatus = 7
            else if (bajaAnexos.length > 0 && altaAnexos.length == 0) estatus = 2
            else if (bajaAnexos.length == 0 && altaAnexos.length > 0) estatus = 7
        }

        if ((valores.actualizacioncadena && ((dataCliente.productormaguey && productormagueyaltabaja) ||
            (dataCliente.viverista && viveristaaltabaja) || (fc_36.comercializadorbebidasaltabaja && fc_36.comercializadorbebidas) ||
            (dataCliente.comercializadormezcal && comercializadormezcalaltabaja) || (dataCliente.comercializadorbebidasmezcal && comercializadorbebidasaltabaja) ||
            (!fc_36.envasador && envasadoraltabaja && (marcas.length == 0 && marcasBebidas.length == 0)) ||
            (!fc_36.productormezcal && productormezcalaltabaja && (marcas.length == 0 && marcasBebidas.length == 0)))
            //&& (!envasadoraltabaja && !productormezcalaltabaja)
        ) && (altaMarcasBebidas.length == 0 && altaMarcas.length == 0)) estatus = 2
        else if (valores.actualizacioncadena) estatus = 7

        if (valores.actualizacioncadena && (viveros.filter(anexo => anexo.alta == true).length > 0 || predios.filter(anexo => anexo.alta == true).length > 0 ||
            marcas.filter(anexo => anexo.alta == true).length > 0 || marcasBebidas.filter(anexo => anexo.alta == true).length > 0)) estatus = 7
        if (valores.cambiorazon) estatus = 7

        const solicitud = {
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, nombrerazonsocial: dataCliente.nombrerazonsocial,
            actualizarmedioscontacto: valores.actualizarmedioscontacto, cambiorazon: valores.cambiorazon, actualizacioncadena: valores.actualizacioncadena,
            actualizaciondomicilio: valores.actualizaciondomicilio, cambioresponsable: valores.cambioresponsable,
            cambiorepresentante: valores.cambiorepresentante, cambioresponsableinst: valores.cambioresponsableinst, actualizarmarcas: valores.actualizarmarcas,
            viverista: valores.viverista, productormaguey: valores.productormaguey, productormezcal: valores.productormezcal,
            envasador: valores.envasador, comercializadormezcal: valores.comercializadormezcal,
            comercializadorbebidas: valores.comercializadorbebidas, actualizacionprediosviveros: valores.actualizacionprediosviveros,
            actualizacioninstalaciones: valores.actualizacioninstalaciones,

            viveristaaltabaja: viveristaaltabaja, productormagueyaltabaja: productormagueyaltabaja,
            productormezcalaltabaja: productormezcalaltabaja, envasadoraltabaja: envasadoraltabaja,
            comercializadormezcalaltabaja: comercializadormezcalaltabaja, comercializadorbebidasaltabaja: comercializadorbebidasaltabaja,

            medioscontactosi: valores.medioscontactosi, medioscontactono: valores.medioscontactono,
            repesentantelegalsi: valores.repesentantelegalsi, repesentantelegalno: valores.repesentantelegalno,
            personaautorizadasi: valores.personaautorizadasi, personaautorizadano: valores.personaautorizadano,
            domiciliofiscalsi: valores.domiciliofiscalsi, domiciliofiscalno: valores.domiciliofiscalno,
            actualizacionprediossi: valores.actualizacionprediossi, actualizacionprediosno: valores.actualizacionprediosno,
            actualizacionviverossi: valores.actualizacionviverossi, actualizacionviverosno: valores.actualizacionviverosno,
            actualizacioninstalacionsi: valores.actualizacioninstalacionsi, actualizacioninstalacionno: valores.actualizacioninstalacionno,

            fechadenacimiento: fechanacimiento, sexo: valores.sexo, estadocivil: valores.estadocivil,
            escolaridad: valores.escolaridad, discapacidadno: valores.discapacidadno, discapacidadsi: valores.discapacidadsi,
            tipodiscapacidad: valores.tipodiscapacidad, lenguaindijenasi: valores.lenguaindijenasi, lenguaindijenano: valores.lenguaindijenano,
            tipoLengua: valores.tipoLengua, ocupacion: valores.ocupacion, numerohijos: valores.numerohijos,
            tipoempresa: valores.tipoempresa, rfc: valores.rfc, actualizacionnombrerazon: valores.actualizacionnombrerazon,
            certificacionsi: valores.certificacionsi, certificacionno: valores.certificacionno,
            empresacertificadora: valores.empresacertificadora, numerohombres: valores.numerohombres.toString(),
            numeromujeres: valores.numeromujeres.toString(), numerodiscapacitados: valores.numerodiscapacitados.toString(),
            numerobase: valores.numerobase.toString(), numeroeventuales: valores.numeroeventuales.toString(),
            idestatusdesolicitudes: estatus, idlogin: idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, folio: consFolio,
        }

        let objetoCompleto = {
            solicitud: solicitud, mediosContacto: mediosContacto,
            responsablesLegales: responsablesLegales, personaAutorizada: personaAutorizada,
            domiciliosFiscales: domicilio, predios: predios, viveros: viveros, instalaciones: anexoInstalaciones,
            responsableInst: responsableInst, marcas: marcas, marcasBebidas: marcasBebidas
        }
        const resultado = await dispatch(registrarSolicitudFC_36Accion(objetoCompleto))
        await dispatch(actualizarLoadingApp_false())
        if (estatus == 2) {
            setFolio(consFolio)
            setEnvioCorrecto(true)
        }
        await dispatch(resetDataFC_36())
        functionResetForm.function()
        if (estatus == 7) {
            await dispatch(obtenerSolicitudesWithStatus({ status: estatus, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
            window.location.reload(true)
        }
    }


    const enviarCorreccion = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        let fechaSolicitud = new Date(fechaHoy).toISOString()
        let fechanacimiento = ''
        if (valores.fechadenacimiento) fechanacimiento = new Date(valores.fechadenacimiento).toISOString()
        else fechanacimiento = null

        const solicitud = {idfc36_solicitudactualizacion:fc_36?.idfc36_solicitudactualizacion,
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente, nombrerazonsocial: dataCliente.nombrerazonsocial,
            actualizarmedioscontacto: valores.actualizarmedioscontacto, cambiorazon: valores.cambiorazon, actualizacioncadena: valores.actualizacioncadena,
            actualizaciondomicilio: valores.actualizaciondomicilio, cambioresponsable: valores.cambioresponsable,
            cambiorepresentante: valores.cambiorepresentante, cambioresponsableinst: valores.cambioresponsableinst, actualizarmarcas: valores.actualizarmarcas,
            viverista: valores.viverista, productormaguey: valores.productormaguey, productormezcal: valores.productormezcal,
            envasador: valores.envasador, comercializadormezcal: valores.comercializadormezcal,
            comercializadorbebidas: valores.comercializadorbebidas, actualizacionprediosviveros: valores.actualizacionprediosviveros,
            actualizacioninstalaciones: valores.actualizacioninstalaciones,

            viveristaaltabaja: viveristaaltabaja, productormagueyaltabaja: productormagueyaltabaja,
            productormezcalaltabaja: productormezcalaltabaja, envasadoraltabaja: envasadoraltabaja,
            comercializadormezcalaltabaja: comercializadormezcalaltabaja, comercializadorbebidasaltabaja: comercializadorbebidasaltabaja,

            medioscontactosi: valores.medioscontactosi, medioscontactono: valores.medioscontactono,
            repesentantelegalsi: valores.repesentantelegalsi, repesentantelegalno: valores.repesentantelegalno,
            personaautorizadasi: valores.personaautorizadasi, personaautorizadano: valores.personaautorizadano,
            domiciliofiscalsi: valores.domiciliofiscalsi, domiciliofiscalno: valores.domiciliofiscalno,
            actualizacionprediossi: valores.actualizacionprediossi, actualizacionprediosno: valores.actualizacionprediosno,
            actualizacionviverossi: valores.actualizacionviverossi, actualizacionviverosno: valores.actualizacionviverosno,
            actualizacioninstalacionsi: valores.actualizacioninstalacionsi, actualizacioninstalacionno: valores.actualizacioninstalacionno,

            fechadenacimiento: fechanacimiento, sexo: valores.sexo, estadocivil: valores.estadocivil,
            escolaridad: valores.escolaridad, discapacidadno: valores.discapacidadno, discapacidadsi: valores.discapacidadsi,
            tipodiscapacidad: valores.tipodiscapacidad, lenguaindijenasi: valores.lenguaindijenasi, lenguaindijenano: valores.lenguaindijenano,
            tipoLengua: valores.tipoLengua, ocupacion: valores.ocupacion, numerohijos: valores.numerohijos,
            tipoempresa: valores.tipoempresa, rfc: valores.rfc, actualizacionnombrerazon: valores.actualizacionnombrerazon,
            certificacionsi: valores.certificacionsi, certificacionno: valores.certificacionno,
            empresacertificadora: valores.empresacertificadora, numerohombres: valores.numerohombres.toString(),
            numeromujeres: valores.numeromujeres.toString(), numerodiscapacitados: valores.numerodiscapacitados.toString(),
            numerobase: valores.numerobase.toString(), numeroeventuales: valores.numeroeventuales.toString(),
            idestatusdesolicitudes: 6
        }

        let objetoCompleto = {
            solicitud: solicitud, mediosContacto: mediosContacto,
            responsablesLegales: responsablesLegales, personaAutorizada: personaAutorizada,
            domiciliosFiscales: domicilio, predios: predios, viveros: viveros, instalaciones: anexoInstalaciones,
            responsableInst: responsableInst, marcas: marcas, marcasBebidas: marcasBebidas
        }
        const resultado = await dispatch(actualizarFC_36Solicitud(objetoCompleto))
        const idSolicitud = data.idfc36_solicitudactualizacion
        const estatusNuevo = 6
        const idCliente = null //Se necesita obtener del cliente, a traves del login 
        const tablaFC_36 = 10
        const tabla = tablaFC_36
        await dispatch(actualizarFC_36Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
        ))
        await dispatch(resetDataFC_36())
        handleResetAllPropertys()
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/solicitudes')
    }






















    const botonAgregarAnexoAlmacen = async () => {
        props.history.push('/fc_36AnexoAlmacen')
    }

    const botonAgregarAnexoEnvasado = async () => {
        props.history.push('/fc_36AnexoEnvasado')
    }

    const botonAgregarAnexoProduccion = async () => {
        props.history.push('/fc_36AnexoProduccion')
    }







    let mediosContacto = useSelector(store => store.FC_36Solicitud.mediosContacto)
    const handdleMediosContacto = async (objectProducto) => {
        await dispatch(agregarMediosContacto(objectProducto))
    }
    const handdleRemovePrevMediosContacto = async (objectProducto) => {
        if (objectProducto.data.idfc36_anexomediodecontacto) {
            await dispatch(eliminarFC_36AnexoMedioContactoBD(objectProducto.data.idfc36_anexomediodecontacto))
        }
        const filtro = mediosContacto.filter(anexo => anexo.id !== objectProducto.data.id)
        await dispatch(editarMediosContacto(filtro))
    }
    const handdleEditPrevMediosContacto = async (paramsObjectProducto) => {
        const { ...objectProducto } = paramsObjectProducto
        if (JSON.stringify({}) !== JSON.stringify(fc_36Map)) {
            const filtro = mediosContacto.findIndex(anexo => anexo.idfc36_anexomediodecontacto === objectProducto.id)
            let editar = { ...mediosContacto[Number(filtro)] }
            const filtroEliminar = mediosContacto.filter(anexo => anexo.idfc36_anexomediodecontacto !== objectProducto.id)
            editar.correoelectronico = objectProducto.correoelectronico
            editar.telefono = objectProducto.telefono
            filtroEliminar.push(editar)
            await dispatch(editarMediosContacto(filtroEliminar))
        } else {
            const filtro = mediosContacto.findIndex(anexo => anexo.id === objectProducto.id)
            let editar = mediosContacto
            const newProductos = []
            for (const i in mediosContacto) {
                const { ...restProducto } = mediosContacto[i]
                newProductos.push(restProducto)
            }
            newProductos[Number(filtro)].correoelectronico = objectProducto.correoelectronico
            newProductos[Number(filtro)].telefono = objectProducto.telefono
            await dispatch(editarMediosContacto(newProductos))
        }
    }
    const handdleMediosContactoBaja = async (objectProducto) => {
        const filtro = mediosContacto.findIndex(anexo => anexo.id === objectProducto.id)
        const newProductos = []
        for (const i in mediosContacto) {
            const { ...restProducto } = mediosContacto[i]
            newProductos.push(restProducto)
        }
        if (newProductos[Number(filtro)].baja === true) newProductos[Number(filtro)].baja = false
        else newProductos[Number(filtro)].baja = true
        await dispatch(editarMediosContacto(newProductos))
    }
    /*const handdleMediosContactoAlta = async (objectProducto) => {
        const filtro = mediosContacto.findIndex(anexo => anexo.id === objectProducto.id)
        const newProductos = []
        for (const i in mediosContacto) {
            const { ...restProducto } = mediosContacto[i]
            newProductos.push(restProducto)
        }
        if (newProductos[Number(filtro)].alta === true) newProductos[Number(filtro)].alta = false
        else newProductos[Number(filtro)].alta = true
        //await setMediosContacto(newProductos)
        await dispatch(editarMediosContacto(newProductos))
    }*/

    //Datos para funcion de resposables legales
    let responsablesLegales = useSelector(store => store.FC_36Solicitud.apoderadosLegales)
    const handdleResponsablesLegales = async (objectProducto) => {
        await dispatch(agregarRepresentanteLegal(objectProducto))
    }
    const handdleRemovePrevResponsablesLegales = async (objectProducto) => {
        if (objectProducto.data.idfc36_anexoapoderadoslegales) {
            await dispatch(eliminarFC_36AnexoRepresentanteLegalBD(objectProducto.data.idfc36_anexoapoderadoslegales))
        }
        const filtro = responsablesLegales.filter(anexo => anexo.id !== objectProducto.data.id)
        await dispatch(editarRepresentanteLegal(filtro))
    }
    const handdleEditPrevResponsablesLegales = async (paramsObjectProducto) => {
        const { ...objectProducto } = paramsObjectProducto
        if (JSON.stringify({}) !== JSON.stringify(fc_36Map)) {
            const filtro = responsablesLegales.findIndex(anexo => anexo.idfc36_anexoapoderadoslegales === objectProducto.id)
            const filtroPrincipal = responsablesLegales.filter(anexo => anexo.principal == true)
            //let editar = { ...responsablesLegales[Number(filtro)] }
            //const filtroEliminar = responsablesLegales.filter(anexo => anexo.idfc36_anexoapoderadoslegales !== objectProducto.id)
            const newProductos = []
            for (const i in responsablesLegales) {
                const { ...restProducto } = responsablesLegales[i]
                newProductos.push(restProducto)
            }
            newProductos[Number(filtro)].representantelegal = objectProducto.representantelegal
            newProductos[Number(filtro)].correoelectronico = objectProducto.correoelectronico
            newProductos[Number(filtro)].telefono = objectProducto.telefono
            newProductos[Number(filtro)].principal = objectProducto.principal
            /*editar.representantelegal = objectProducto.representantelegal
            editar.correoelectronico = objectProducto.correoelectronico
            editar.telefono = objectProducto.telefono
            filtroEliminar.push(editar)
            await dispatch(editarRepresentanteLegal(filtroEliminar))*/
            //if(filtroPrincipal != -1) newProductos[Number(filtroPrincipal)].principal = objectProducto.principal
            await dispatch(editarRepresentanteLegal(newProductos))
        } else {
            const filtro = responsablesLegales.findIndex(anexo => anexo.id === objectProducto.id)
            const filtroPrincipal = responsablesLegales.findIndex(anexo => anexo.principal == true)
            let editar = responsablesLegales
            const newProductos = []
            for (const i in responsablesLegales) {
                const { ...restProducto } = responsablesLegales[i]
                newProductos.push(restProducto)
            }
            newProductos[Number(filtro)].representantelegal = objectProducto.representantelegal
            newProductos[Number(filtro)].correoelectronico = objectProducto.correoelectronico
            newProductos[Number(filtro)].telefono = objectProducto.telefono
            newProductos[Number(filtro)].principal = objectProducto.principal
            if (filtroPrincipal != -1 && !(newProductos[Number(filtroPrincipal)].baja == false || newProductos[Number(filtroPrincipal)].baja == true)) newProductos[Number(filtroPrincipal)].principal = objectProducto.principal
            await dispatch(editarRepresentanteLegal(newProductos))

        }
    }
    const handdleApoderadosLegalesBaja = async (objectProducto) => {
        const filtro = responsablesLegales.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroPrincipal = responsablesLegales.findIndex(anexo => anexo.principal == true && anexo.baja == null)

        const newProductos = []
        for (const i in responsablesLegales) {
            const { ...restProducto } = responsablesLegales[i]
            newProductos.push(restProducto)
        }

        if (newProductos[Number(filtro)].baja === true) {
            if (newProductos[Number(filtro)].principal == true && fc_36.tipoempresa == 'fisica') {
                newProductos[Number(filtro)].baja = true
            } else {
                newProductos[Number(filtro)].baja = false
            }
        } else {
            if (newProductos[Number(filtro)].principal == true && fc_36.tipoempresa == 'fisica') {
                newProductos[Number(filtro)].baja = true
            } else {
                newProductos[Number(filtro)].baja = true
            }

        }

        if (filtroPrincipal != -1) newProductos[Number(filtroPrincipal)].principal = false



        await dispatch(editarRepresentanteLegal(newProductos))
    }
    /*const handdleApoderadosLegalesAlta = async (objectProducto) => {
        const filtro = responsablesLegales.findIndex(anexo => anexo.id === objectProducto.id)
        const newProductos = []
        for (const i in responsablesLegales) {
            const { ...restProducto } = responsablesLegales[i]
            newProductos.push(restProducto)
        }
        if (newProductos[Number(filtro)].alta === true) newProductos[Number(filtro)].alta = false
        else newProductos[Number(filtro)].alta = true
        await dispatch(editarRepresentanteLegal(newProductos))
    }*/

    let personaAutorizada = useSelector(store => store.FC_36Solicitud.personasAutorizadas)
    const handdlePersonaAutorizada = async (objectProducto) => {
        await dispatch(agregarPersonaAutorizada(objectProducto))
    }
    const handdleRemovePrevPersonaAutorizada = async (objectProducto) => {
        if (objectProducto.data.idfc36_anexopersonasautorizadas) {
            await dispatch(eliminarFC_36AnexoPersonaAutorizadaBD(objectProducto.data.idfc36_anexopersonasautorizadas))
        }
        const filtro = personaAutorizada.filter(anexo => anexo.id !== objectProducto.data.id)
        await dispatch(editarPersonaAutorizada(filtro))

    }
    const handdleEditPrevPersonaAutorizada = async (paramsObjectProducto) => {
        const { ...objectProducto } = paramsObjectProducto
        if (JSON.stringify({}) !== JSON.stringify(fc_36Map)) {
            const filtro = personaAutorizada.findIndex(anexo => anexo.idfc36_anexopersonasautorizadas === objectProducto.id)
            let editar = { ...personaAutorizada[Number(filtro)] }
            const filtroEliminar = personaAutorizada.filter(anexo => anexo.idfc36_anexopersonasautorizadas !== objectProducto.id)
            editar.personaautoriazadaparatramites = objectProducto.personaautoriazadaparatramites
            editar.correoelectronico = objectProducto.correoelectronico
            editar.telefono = objectProducto.telefono
            filtroEliminar.push(editar)
            await dispatch(editarPersonaAutorizada(filtroEliminar))

        } else {
            const filtro = personaAutorizada.findIndex(anexo => anexo.id === objectProducto.id)
            let editar = personaAutorizada
            const newProductos = []
            for (const i in personaAutorizada) {
                const { ...restProducto } = personaAutorizada[i]
                newProductos.push(restProducto)
            }
            newProductos[Number(filtro)].personaautoriazadaparatramites = objectProducto.personaautoriazadaparatramites
            newProductos[Number(filtro)].correoelectronico = objectProducto.correoelectronico
            newProductos[Number(filtro)].telefono = objectProducto.telefono
            await dispatch(editarPersonaAutorizada(newProductos))

        }
    }
    const handdlePersonaAutorizadaBaja = async (objectProducto) => {
        const filtro = personaAutorizada.findIndex(anexo => anexo.id === objectProducto.id)
        const newProductos = []
        for (const i in personaAutorizada) {
            const { ...restProducto } = personaAutorizada[i]
            newProductos.push(restProducto)
        }
        if (newProductos[Number(filtro)].baja === true) newProductos[Number(filtro)].baja = false
        else newProductos[Number(filtro)].baja = true
        await dispatch(editarPersonaAutorizada(newProductos))
    }
    /*const handdlePersonaAutorizadaAlta = async (objectProducto) => {
        const filtro = personaAutorizada.findIndex(anexo => anexo.id === objectProducto.id)
        const newProductos = []
        for (const i in personaAutorizada) {
            const { ...restProducto } = personaAutorizada[i]
            newProductos.push(restProducto)
        }
        if (newProductos[Number(filtro)].alta === true) newProductos[Number(filtro)].alta = false
        else newProductos[Number(filtro)].alta = true
        await dispatch(editarPersonaAutorizada(newProductos))
    }*/

    //const [domicilio, setDomicilio] = React.useState([])
    let domicilio = useSelector(store => store.FC_36Solicitud.domiciliosFiscales)
    const handdleDomiclio = async (objectProducto) => {
        if (objectProducto.domicilioprincipal) {
            const filtro = domicilio.findIndex(anexo => anexo.domicilioprincipal == true)
            const newProductos = []
            for (const i in domicilio) {
                const { ...restProducto } = domicilio[i]
                newProductos.push(restProducto)
            }
            if (filtro != -1) newProductos[Number(filtro)].domicilioprincipal = false
            newProductos.push(objectProducto)
            await dispatch(editarDomicilioFiscal(newProductos))
        } else {
            await dispatch(agregarDomicilioFiscal(objectProducto))
        }
    }

    const handdleRemoveDomicilioPrev = async (objectProducto) => {
        if (objectProducto.data.idfc31_anexomuestreo) {
            await dispatch(eliminarFC_31AnexoMuestreoBD(objectProducto.data.idfc31_anexomuestreo))
        }
        const filtro = domicilio.filter(anexo => anexo.id !== objectProducto.data.id)
        await dispatch(editarDomicilioFiscal(filtro))

    }
    const handdleEditDomicilioPrev = async (paramsObjectProducto) => {
        const { ...objectProducto } = paramsObjectProducto
        if (JSON.stringify({}) !== JSON.stringify(fc_36Map)) {
            const filtroPrincipal = domicilio.findIndex(anexo => anexo.domicilioprincipal == true)
            const filtro = domicilio.findIndex(anexo => anexo.idfc36_anexodomiciliosfiscales === objectProducto.id)
            const newProductos = []
            for (const i in domicilio) {
                const { ...restProducto } = domicilio[i]
                newProductos.push(restProducto)
            }
            newProductos[Number(filtroPrincipal)].domicilioprincipal = false
            /*let editar = { ...domicilio[Number(filtro)] }
            const filtroEliminar = domicilio.filter(anexo => anexo.idfc36_anexodomiciliosfiscales !== objectProducto.id)*/
            newProductos[Number(filtro)].domicilio = objectProducto.domicilio
            newProductos[Number(filtro)].estado = objectProducto.estado
            newProductos[Number(filtro)].codigopostal = objectProducto.codigopostal
            newProductos[Number(filtro)].localidad = objectProducto.localidad
            newProductos[Number(filtro)].calle = objectProducto.calle
            newProductos[Number(filtro)].otracalle = objectProducto.otracalle
            newProductos[Number(filtro)].numeroexterior = objectProducto.numeroexterior
            newProductos[Number(filtro)].numerointerior = objectProducto.numerointerior
            newProductos[Number(filtro)].domicilioprincipal = objectProducto.domicilioprincipal
            await dispatch(editarDomicilioFiscal(newProductos))

        } else {
            const filtroPrincipal = domicilio.findIndex(anexo => anexo.domicilioprincipal == true)
            const filtro = domicilio.findIndex(anexo => anexo.id === objectProducto.id)
            const newProductos = []
            for (const i in domicilio) {
                const { ...restProducto } = domicilio[i]
                newProductos.push(restProducto)
            }
            newProductos[Number(filtroPrincipal)].domicilioprincipal = false

            newProductos[Number(filtro)].domicilio = objectProducto.domicilio
            newProductos[Number(filtro)].estado = objectProducto.estado
            newProductos[Number(filtro)].codigopostal = objectProducto.codigopostal
            newProductos[Number(filtro)].localidad = objectProducto.localidad
            newProductos[Number(filtro)].calle = objectProducto.calle
            newProductos[Number(filtro)].otracalle = objectProducto.otracalle
            newProductos[Number(filtro)].numeroexterior = objectProducto.numeroexterior
            newProductos[Number(filtro)].numerointerior = objectProducto.numerointerior
            newProductos[Number(filtro)].domicilioprincipal = objectProducto.domicilioprincipal
            await dispatch(editarDomicilioFiscal(newProductos))

        }
    }
    const handdleDomicilioFiscalBaja = async (objectProducto) => {
        const filtro = domicilio.findIndex(anexo => anexo.id === objectProducto.id)
        const newProductos = []
        for (const i in domicilio) {
            const { ...restProducto } = domicilio[i]
            newProductos.push(restProducto)
        }
        if (newProductos[Number(filtro)].baja === true) newProductos[Number(filtro)].baja = false
        else {
            newProductos[Number(filtro)].baja = true
            newProductos[Number(filtro)].domicilioprincipal = false
        }
        await dispatch(editarDomicilioFiscal(newProductos))
    }
    /*const handdleDomicilioFiscalAlta = async (objectProducto) => {
        const filtro = domicilio.findIndex(anexo => anexo.id === objectProducto.id)
        const newProductos = []
        for (const i in domicilio) {
            const { ...restProducto } = domicilio[i]
            newProductos.push(restProducto)
        }
        if (newProductos[Number(filtro)].alta === true) {
            newProductos[Number(filtro)].alta = false
            newProductos[Number(filtro)].domicilioprincipal = false
        } else newProductos[Number(filtro)].alta = true
        await dispatch(editarDomicilioFiscal(newProductos))
    }
    const handdleDomicilioFiscalSucursal = async (objectProducto) => {
        let domiciliosFiscales = []
        for (const i in domicilio) {
            const { ...dato } = domicilio[i]
            if (dato.id === objectProducto.data.id) {
                dato.domicilioprincipal = true
                domiciliosFiscales.push(dato)
            } else {
                dato.domicilioprincipal = false
                domiciliosFiscales.push(dato)
            }
        }
        await dispatch(editarDomicilioFiscal(domiciliosFiscales))
    }*/

    let marcas = useSelector(store => store.FC_36Solicitud.marcas)
    const handdleMarcas = async (objectProducto) => {
        await dispatch(agregarMarcas(objectProducto))
    }
    const handdleRemovePrevMarcas = async (objectProducto) => {
        if (objectProducto.data.idfc36_anexomarcas) {
            await dispatch(eliminarFC_31AnexoMuestreoBD(objectProducto.data.idfc36_anexomarcas))
        }
        const filtro = marcas.filter(anexo => anexo.id !== objectProducto.data.id)
        await dispatch(editarMarcas(filtro))
    }
    const handdleEditPrevMarcas = async (paramsObjectProducto) => {
        const { ...objectProducto } = paramsObjectProducto
        if (JSON.stringify({}) !== JSON.stringify(fc_36Map)) {
            const filtro = marcas.findIndex(anexo => anexo.idfc36_anexomarcas === objectProducto.id)
            let editar = { ...marcas[Number(filtro)] }
            const filtroEliminar = marcas.filter(anexo => anexo.idfc36_anexomarcas !== objectProducto.id)
            editar.marcaregistrada = objectProducto.marcaregistrada
            editar.nombremarca = objectProducto.nombremarca
            editar.numeroregistro = objectProducto.numeroregistro
            editar.tipomarca = objectProducto.tipomarca
            editar.titularidad = objectProducto.titularidad
            editar.productorautorizado = objectProducto.productorautorizado
            editar.maquiladorautorizado = objectProducto.maquiladorautorizado
            if (editar.idmarcascliente) editar.iscorregida = true
            filtroEliminar.push(editar)
            await dispatch(editarMarcas(filtroEliminar))
        } else {
            const filtro = marcas.findIndex(anexo => anexo.id === objectProducto.id)
            let editar = marcas
            const newProductos = []
            for (const i in marcas) {
                const { ...restProducto } = marcas[i]
                newProductos.push(restProducto)
            }
            newProductos[Number(filtro)].marcaregistrada = objectProducto.marcaregistrada
            newProductos[Number(filtro)].nombremarca = objectProducto.nombremarca
            newProductos[Number(filtro)].numeroregistro = objectProducto.numeroregistro
            newProductos[Number(filtro)].tipomarca = objectProducto.tipomarca
            newProductos[Number(filtro)].titularidad = objectProducto.titularidad
            newProductos[Number(filtro)].productorautorizado = objectProducto.productorautorizado
            newProductos[Number(filtro)].maquiladorautorizado = objectProducto.maquiladorautorizado
            if (newProductos[Number(filtro)].idmarcascliente) newProductos[Number(filtro)].iscorregida = true
            await dispatch(editarMarcas(newProductos))
        }
    }
    const handdleMarcasBaja = async (objectProducto) => {
        const filtro = marcas.findIndex(anexo => anexo.id === objectProducto.id)
        const newProductos = []
        for (const i in marcas) {
            const { ...restProducto } = marcas[i]
            newProductos.push(restProducto)
        }
        if (!fc_36.cambiorazon) {
            if (newProductos[Number(filtro)].baja === true) newProductos[Number(filtro)].baja = false
            else newProductos[Number(filtro)].baja = true
        }
        await dispatch(editarMarcas(newProductos))
    }
    /*const handdleMarcasAlta = async (objectProducto) => {
        const filtro = marcas.findIndex(anexo => anexo.id === objectProducto.id)
        const newProductos = []
        for (const i in marcas) {
            const { ...restProducto } = marcas[i]
            newProductos.push(restProducto)
        }
        if (newProductos[Number(filtro)].alta === true) newProductos[Number(filtro)].alta = false
        else newProductos[Number(filtro)].alta = true
        await dispatch(editarMarcas(newProductos))
    }*/




    let marcasBebidas = useSelector(store => store.FC_36Solicitud.marcasBebidas)
    const handdleMarcasBebidas = async (objectProducto) => {
        await dispatch(agregarMarcasBebidas(objectProducto))

    }
    const handdleRemovePrevMarcasBebidas = async (objectProducto) => {
        if (objectProducto.data.idfc36_anexomarcasproductoconmezcal) {
            await dispatch(eliminarFC_31AnexoMuestreoBD(objectProducto.data.idfc36_anexomarcasproductoconmezcal))
        }
        const filtro = marcasBebidas.filter(anexo => anexo.id !== objectProducto.data.id)
        await dispatch(editarMarcasBebidas(filtro))
    }
    const handdleEditPrevMarcasBebidas = async (paramsObjectProducto) => {
        const { ...objectProducto } = paramsObjectProducto
        if (JSON.stringify({}) !== JSON.stringify(fc_36Map)) {
            const filtro = marcasBebidas.findIndex(anexo => anexo.idfc36_anexomarcasproductoconmezcal === objectProducto.id)
            let editar = { ...marcasBebidas[Number(filtro)] }
            const filtroEliminar = marcasBebidas.filter(anexo => anexo.idfc36_anexomarcasproductoconmezcal !== objectProducto.id)
            editar.marcaregistrada = objectProducto.marcaregistrada
            editar.nombremarca = objectProducto.nombremarca
            editar.numeroregistro = objectProducto.numeroregistro
            editar.tipomarca = objectProducto.tipomarca
            editar.titularidad = objectProducto.titularidad
            editar.productorautorizado = objectProducto.productorautorizado
            editar.maquiladorautorizado = objectProducto.maquiladorautorizado
            if (editar.idmarcasproductocliente) editar.iscorregida = true
            filtroEliminar.push(editar)
            await dispatch(editarMarcasBebidas(filtroEliminar))
        } else {
            const filtro = marcasBebidas.findIndex(anexo => anexo.id === objectProducto.id)
            let editar = marcasBebidas
            const newProductos = []
            for (const i in marcasBebidas) {
                const { ...restProducto } = marcasBebidas[i]
                newProductos.push(restProducto)
            }
            newProductos[Number(filtro)].marcaregistrada = objectProducto.marcaregistrada
            newProductos[Number(filtro)].nombremarca = objectProducto.nombremarca
            newProductos[Number(filtro)].numeroregistro = objectProducto.numeroregistro
            newProductos[Number(filtro)].tipomarca = objectProducto.tipomarca
            newProductos[Number(filtro)].titularidad = objectProducto.titularidad
            newProductos[Number(filtro)].productorautorizado = objectProducto.productorautorizado
            newProductos[Number(filtro)].maquiladorautorizado = objectProducto.maquiladorautorizado
            if (newProductos[Number(filtro)].idmarcasproductocliente) newProductos[Number(filtro)].iscorregida = true
            await dispatch(editarMarcasBebidas(newProductos))
        }
    }
    const handdleMarcasBebidaBaja = async (objectProducto) => {
        const filtro = marcasBebidas.findIndex(anexo => anexo.id === objectProducto.id)
        const newProductos = []
        for (const i in marcasBebidas) {
            const { ...restProducto } = marcasBebidas[i]
            newProductos.push(restProducto)
        }
        if (!fc_36.cambiorazon) {
            if (newProductos[Number(filtro)].baja === true) newProductos[Number(filtro)].baja = false
            else newProductos[Number(filtro)].baja = true
        }
        await dispatch(editarMarcasBebidas(newProductos))
    }
    /*const handdleMarcasBebidaAlta = async (objectProducto) => {
        const filtro = marcasBebidas.findIndex(anexo => anexo.id === objectProducto.id)
        const newProductos = []
        for (const i in marcasBebidas) {
            const { ...restProducto } = marcasBebidas[i]
            newProductos.push(restProducto)
        }
        if (newProductos[Number(filtro)].alta === true) newProductos[Number(filtro)].alta = false
        else newProductos[Number(filtro)].alta = true
        await dispatch(editarMarcasBebidas(newProductos))
    }*/

    let responsableInst = useSelector(store => store.FC_36Solicitud.responsablesInstalaciones)
    let tipoInstalaciones = useSelector(store => store.FC_36Solicitud.tipoInstalaciones)
    let aliasInstalaciones = useSelector(store => store.FC_36Solicitud.aliasInstalaciones)
    const [filtroalias, setFiltroAlias] = React.useState([])

    const handdleResponsableInstalaciones = async (objectProducto) => {
        await dispatch(agregarResponsableInstalacion(objectProducto))
    }
    const handdleRemovePrevResponsableInstalaciones = async (objectProducto) => {
        if (objectProducto.data.idfc36_anexopersonasautorizadas) {
            await dispatch(eliminarFC_36AnexoPersonaAutorizadaBD(objectProducto.data.idfc36_anexopersonasautorizadas))
        }
        const filtro = responsableInst.filter(anexo => anexo.id !== objectProducto.data.id)
        await dispatch(editarResponsableInstalacion(filtro))

    }
    const handdleEditPrevResponsableInstalaciones = async (paramsObjectProducto) => {
        const { ...objectProducto } = paramsObjectProducto
        if (JSON.stringify({}) !== JSON.stringify(fc_36Map)) {
            const filtro = responsableInst.findIndex(anexo => anexo.idfc_36_actulizarresponsableinstalaciones === objectProducto.id)
            let editar = { ...responsableInst[Number(filtro)] }
            const filtroEliminar = responsableInst.filter(anexo => anexo.idfc_36_actulizarresponsableinstalaciones !== objectProducto.id)
            editar.tipoinstalacion = objectProducto.tipoinstalacion
            editar.alias = objectProducto.alias
            editar.responsableinstalacion = objectProducto.responsableinstalacion
            editar.correoelectronico = objectProducto.correoelectronico
            editar.telefono = objectProducto.telefono
            editar.domicilio = objectProducto.domicilio
            filtroEliminar.push(editar)
            await dispatch(editarResponsableInstalacion(filtroEliminar))

        } else {
            const filtro = responsableInst.findIndex(anexo => anexo.id === objectProducto.id)
            let editar = responsableInst
            const newProductos = []
            for (const i in responsableInst) {
                const { ...restProducto } = responsableInst[i]
                newProductos.push(restProducto)
            }
            newProductos[Number(filtro)].tipoinstalacion = objectProducto.tipoinstalacion
            newProductos[Number(filtro)].alias = objectProducto.alias
            newProductos[Number(filtro)].responsableinstalacion = objectProducto.responsableinstalacion
            newProductos[Number(filtro)].correoelectronico = objectProducto.correoelectronico
            newProductos[Number(filtro)].telefono = objectProducto.telefono
            newProductos[Number(filtro)].domicilio = objectProducto.domicilio
            await dispatch(editarResponsableInstalacion(newProductos))

        }
    }
    const handdleResponsableInstalacionBaja = async (objectProducto) => {
        const filtro = responsableInst.findIndex(anexo => anexo.id === objectProducto.id)
        const newProductos = []
        for (const i in responsableInst) {
            const { ...restProducto } = responsableInst[i]
            newProductos.push(restProducto)
        }
        if (newProductos[Number(filtro)].baja === true) newProductos[Number(filtro)].baja = false
        else newProductos[Number(filtro)].baja = true
        await dispatch(editarResponsableInstalacion(newProductos))
    }
    /*const handdleResponsableInstalacionAlta = async (objectProducto) => {
        const filtro = responsableInst.findIndex(anexo => anexo.id === objectProducto.id)
        const newProductos = []
        for (const i in responsableInst) {
            const { ...restProducto } = responsableInst[i]
            newProductos.push(restProducto)
        }
        if (newProductos[Number(filtro)].alta === true) newProductos[Number(filtro)].alta = false
        else newProductos[Number(filtro)].alta = true
        await dispatch(editarResponsableInstalacion(newProductos))
    }*/
    const handdleResponsableInstalacionAlias = async (objectProducto) => {
        let tipoInstalacion = 0
        if (objectProducto === 'Unidad de Produccion') tipoInstalacion = 1
        if (objectProducto === 'Unidad de Envasado') tipoInstalacion = 2
        if (objectProducto === 'Unidad de Almacen') tipoInstalacion = 3
        const filtro = aliasInstalaciones.filter(anexo => anexo.idtipoanexo === tipoInstalacion)
        setFiltroAlias(filtro)

    }

    const anexoInstalaciones = useSelector(store => store.FC_36Solicitud.instalaciones)
    const handdleDeleteOptionFileInstalacion = (idAnexo) => {
        if (idAnexo) {
            const newOptions = opcionFileInstalacion.filter(opcion => opcion.idAnexo !== idAnexo)
            if (newOptions !== undefined) {
                setOpcionFileInstalacion(newOptions)
            }
        }
    }
    const handdleInstalacionesBaja = async (objectProducto) => {
        const filtro = anexoInstalaciones.findIndex(anexo => anexo.data.id === objectProducto.id)

        const newProductos = []
        for (const i in anexoInstalaciones) {
            const { ...restProducto } = anexoInstalaciones[i].data
            newProductos.push({ data: restProducto })
        }
        if (newProductos[Number(filtro)].data.baja === true) newProductos[Number(filtro)].data.baja = false
        else newProductos[Number(filtro)].data.baja = true
        await dispatch(editarInstalacionBajaAlta(newProductos))
    }
    const handdleInstalacionesAlta = async (objectProducto) => {
        const filtro = anexoInstalaciones.findIndex(anexo => anexo.data.id === objectProducto.id)
        const newProductos = []
        for (const i in anexoInstalaciones) {
            const { ...restProducto } = anexoInstalaciones[i].data
            newProductos.push({ data: restProducto })
        }
        if (newProductos[Number(filtro)].data.alta === true) newProductos[Number(filtro)].data.alta = false
        else newProductos[Number(filtro)].data.alta = true
        await dispatch(editarInstalacionBajaAlta(newProductos))
    }

















    const predios = useSelector(store => store.FC_36Solicitud.predios)
    const handdlePredio = async (objectProducto) => {
        await dispatch(agregarPredios(objectProducto))
    }
    const handdleRemovePredioPrev = async (objectProducto) => {
        if (objectProducto.data.idfc31_anexomuestreo) {
            await dispatch(eliminarFC_31AnexoMuestreoBD(objectProducto.data.idfc36_anexopredio))
        }
        const filtro = predios.filter(anexo => anexo.id !== objectProducto.data.id)
        await dispatch(editarPredios(filtro))

    }
    const handdleEditPredioPrev = async (paramsObjectProducto) => {
        const { ...objectProducto } = paramsObjectProducto
        if (JSON.stringify({}) !== JSON.stringify(fc_36Map)) {
            const filtro = predios.findIndex(anexo => anexo.idfc36_anexopredio === objectProducto.id)
            let editar = { ...predios[Number(filtro)] }
            const filtroEliminar = predios.filter(anexo => anexo.idfc36_anexopredio !== objectProducto.id)
            editar.nombreparaje = objectProducto.nombreparaje
            editar.estado = objectProducto.estado
            editar.distrito = objectProducto.distrito
            editar.municipio = objectProducto.municipio
            editar.localidad = objectProducto.localidad
            editar.cultivado = objectProducto.cultivado
            editar.semicultivado = objectProducto.semicultivado
            editar.silvestre = objectProducto.silvestre
            editar.domicilio = objectProducto.domicilio
            filtroEliminar.push(editar)
            await dispatch(editarPredios(filtroEliminar))

        } else {
            const filtro = predios.findIndex(anexo => anexo.id === objectProducto.id)
            let editar = predios
            const newProductos = []
            for (const i in predios) {
                const { ...restProducto } = predios[i]
                newProductos.push(restProducto)
            }
            newProductos[Number(filtro)].nombreparaje = objectProducto.nombreparaje
            newProductos[Number(filtro)].estado = objectProducto.estado
            newProductos[Number(filtro)].distrito = objectProducto.distrito
            newProductos[Number(filtro)].municipio = objectProducto.municipio
            newProductos[Number(filtro)].localidad = objectProducto.localidad
            newProductos[Number(filtro)].cultivado = objectProducto.cultivado
            newProductos[Number(filtro)].semicultivado = objectProducto.semicultivado
            newProductos[Number(filtro)].silvestre = objectProducto.silvestre
            newProductos[Number(filtro)].domicilio = objectProducto.domicilio
            await dispatch(editarPredios(newProductos))

        }
    }
    const handdlePrediosBaja = async (objectProducto) => {
        const filtro = predios.findIndex(anexo => anexo.id === objectProducto.id)
        const newProductos = []
        for (const i in predios) {
            const { ...restProducto } = predios[i]
            newProductos.push(restProducto)
        }
        if (newProductos[Number(filtro)].baja === true) newProductos[Number(filtro)].baja = false
        else newProductos[Number(filtro)].baja = true
        await dispatch(editarPredios(newProductos))
    }

    const viveros = useSelector(store => store.FC_36Solicitud.viveros)
    const handdleVivero = async (objectProducto) => {
        await dispatch(agregarViveros(objectProducto))

    }
    const handdleRemoveViveroPrev = async (objectProducto) => {
        if (objectProducto.data.idfc31_anexomuestreo) {
            await dispatch(eliminarFC_31AnexoMuestreoBD(objectProducto.data.idfc31_anexomuestreo))
        }
        const filtro = viveros.filter(anexo => anexo.id !== objectProducto.data.id)
        await dispatch(editarViveros(filtro))

    }
    const handdleEditViveroPrev = async (paramsObjectProducto) => {
        const { ...objectProducto } = paramsObjectProducto
        if (JSON.stringify({}) !== JSON.stringify(fc_36Map)) {
            const filtro = viveros.findIndex(anexo => anexo.idfc_36_anexoviveros === objectProducto.id)
            let editar = { ...viveros[Number(filtro)] }
            const filtroEliminar = viveros.filter(anexo => anexo.idfc_36_anexoviveros !== objectProducto.id)
            editar.nombreparaje = objectProducto.nombreparaje
            editar.estado = objectProducto.estado
            editar.distrito = objectProducto.distrito
            editar.municipio = objectProducto.municipio
            editar.localidad = objectProducto.localidad
            editar.cultivado = objectProducto.cultivado
            editar.semicultivado = objectProducto.semicultivado
            editar.silvestre = objectProducto.silvestre
            editar.domicilio = objectProducto.domicilio
            filtroEliminar.push(editar)
            await dispatch(editarViveros(filtroEliminar))

        } else {
            const filtro = viveros.findIndex(anexo => anexo.id === objectProducto.id)
            let editar = viveros
            const newProductos = []
            for (const i in viveros) {
                const { ...restProducto } = viveros[i]
                newProductos.push(restProducto)
            }
            newProductos[Number(filtro)].nombreparaje = objectProducto.nombreparaje
            newProductos[Number(filtro)].estado = objectProducto.estado
            newProductos[Number(filtro)].distrito = objectProducto.distrito
            newProductos[Number(filtro)].municipio = objectProducto.municipio
            newProductos[Number(filtro)].localidad = objectProducto.localidad
            newProductos[Number(filtro)].cultivado = objectProducto.cultivado
            newProductos[Number(filtro)].semicultivado = objectProducto.semicultivado
            newProductos[Number(filtro)].silvestre = objectProducto.silvestre
            newProductos[Number(filtro)].domicilio = objectProducto.domicilio
            await dispatch(editarViveros(newProductos))

        }
    }
    const handdleViverosBaja = async (objectProducto) => {
        const filtro = viveros.findIndex(anexo => anexo.id === objectProducto.id)
        const newProductos = []
        for (const i in viveros) {
            const { ...restProducto } = viveros[i]
            newProductos.push(restProducto)
        }
        if (newProductos[Number(filtro)].baja === true) newProductos[Number(filtro)].baja = false
        else newProductos[Number(filtro)].baja = true
        await dispatch(editarViveros(newProductos))
    }


    const setCertificacionSiNo = (target) => {
        if (target.id === 'si') {
            if (target.checked) {
                setcertificacionsi(true)
                setcertificacionno(false)
            }
        } else if (target.id === 'no') {
            if (target.checked) {
                setcertificacionno(true)
                setcertificacionsi(false)
            }
        }
    }

    const [openModalBaja, setOpenModalBaja] = React.useState(false);
    const [titleModalBaja, setTitleModalBaja] = React.useState('');
    const [bodyModalBaja, setBodyModalBaja] = React.useState('')
    const [bodyFinalBaja, setBodyFinalBaja] = React.useState('')
    const [tipoBaja, setTipoBaja] = React.useState('')
    const [accionBaja, setAccionBaja] = React.useState('')
    const [dataModalBaja, setDataModalBaja] = React.useState('')

    const handleOpenModalBaja = (data) => {
        setTitleModalBaja(data.title)
        setBodyModalBaja(data.body)
        setAccionBaja(data.accion)
        setTipoBaja(data.tipoBaja)
        setBodyFinalBaja(data.bodyFinalBaja)
        setOpenModalBaja(true)
        setDataModalBaja(data.data)
    }
    const handleCloseModalBaja = () => {
        setTitleModalBaja('')
        setBodyModalBaja('')
        setAccionBaja('')
        setBodyFinalBaja('')
        setTipoBaja('')
        setOpenModalBaja(false)
        setDataModalBaja('')
    }
    const modalComponentBaja = () => {
        return (
            <div>
                <Modal open={openModalBaja} onClose={handleCloseModalBaja}
                    aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: 'red' }}>
                            <center className='text-danger'><b>{titleModalBaja}</b></center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <p className={`${estilos.bodyModal}`}>{bodyModalBaja} <b>{tipoBaja}.</b></p>
                            {bodyFinalBaja} {tipoBaja}
                            <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-success col-md-5' onClick={() => {
                                switch (accionBaja) {
                                    case 'BajaCadena':
                                        altabajaCadena(dataModalBaja)
                                        break;
                                    default:
                                        break;
                                }
                            }}>CONTINUAR</button>
                            <div className='col-md-2'></div>
                            <button className='btn btn-dark col-md-5' onClick={() => handleCloseModalBaja()} >CANCELAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }


    const botonBajaCadena = async (valores, tipoBaja) => {
        let baja = ''
        if (tipoBaja === 'viveristabaja') baja = 'viverista'
        if (tipoBaja === 'productormagueybaja') baja = 'productor de maguey'
        if (tipoBaja === 'productormezcalbaja') baja = 'productor de mezcal'
        if (tipoBaja === 'envasadorbaja') baja = 'envasador'
        if (tipoBaja === 'comercializadormezcalbaja') baja = 'comercializador de mezcal'
        if (tipoBaja === 'comercializadorbebidasbaja') baja = 'comercializador de bebidas con mezcal'
        let { ...values } = valores
        values.tipoBaja = tipoBaja

        handleOpenModalBaja({
            title: `¡Advertencia!`,
            body: `Estas a punto de darte de baja en tu cadena productiva maguey-mezcal como`,
            accion: 'BajaCadena',
            tipoBaja: baja,
            bodyFinalBaja: 'A continuación, se procederá a dar de baja la información de',
            data: values

        })
    }

    const altabajaCadena = async (values, tipo) => {
        if (values.tipoBaja == 'viveristabaja') {
            setviveristaalta(false)
            let { ...dataFC_36 } = values
            dataFC_36.viverista = false
            await setValores(dataFC_36)
            delete dataFC_36.tipoBaja
            await dispatch(agregarFC_36(dataFC_36))
            const filtro = viveros.filter(anexo => anexo.baja !== null)
            const newProductos = []
            for (const i in filtro) {
                const { ...restProducto } = filtro[i]
                if (restProducto.isbaja != true) {
                    restProducto.baja = true
                }
                newProductos.push(restProducto)
            }
            await dispatch(editarViveros(newProductos))
        }
        if (values.tipoBaja == 'viveristabaja' || tipo == 'viveristaalta') setviveristaaltabaja(true)
        if (values.tipoBaja == 'productormagueybaja' || tipo == 'productormagueyalta') setproductormagueyaltabaja(true)
        if (values.tipoBaja == 'productormezcalbaja' || tipo == 'productormezcalalta') setproductormezcalaltabaja(true)
        if (values.tipoBaja == 'envasadorbaja' || tipo == 'envasadoralta') setenvasadoraltabaja(true)
        if (values.tipoBaja == 'comercializadormezcalbaja' || tipo == 'comercializadormezcalalta') setcomercializadormezcalaltabaja(true)
        if (values.tipoBaja == 'comercializadorbebidasbaja' || tipo == 'comercializadorbebidasalta') setcomercializadorbebidasaltabaja(true)

        if ((dataCliente.viverista && viveristaaltabaja && (values.tipoBaja == 'viveristabaja' || tipo == 'viveristaalta')) ||
            (!dataCliente.viverista && viveristaaltabaja && (values.tipoBaja == 'viveristabaja' || tipo == 'viveristaalta'))) setviveristaaltabaja(false)
        if (dataCliente.productormaguey && productormagueyaltabaja && (values.tipoBaja == 'productormagueybaja' || tipo == 'productormagueyalta')) setproductormagueyaltabaja(false)
        if (dataCliente.comercializadormezcal && comercializadormezcalaltabaja && (values.tipoBaja == 'comercializadormezcalbaja' || tipo == 'comercializadormezcalalta')) setcomercializadormezcalaltabaja(false)
        if (dataCliente.comercializadorbebidasmezcal && comercializadorbebidasaltabaja && (values.tipoBaja == 'comercializadorbebidasbaja' || tipo == 'comercializadorbebidasalta')) setcomercializadorbebidasaltabaja(false)
        //if(dataCliente.productormezcal && p) setproductormagueyaltabaja(false)

        if (tipo == 'viveristaalta') {
            setviveristaalta(true)
            let { ...dataFC_36 } = values
            dataFC_36.viverista = true
            dataFC_36.viveristaaltabaja = true
            dataFC_36.actualizacionviverossi = true
            await setValores(dataFC_36)
            delete dataFC_36.tipoBaja
            await dispatch(agregarFC_36(dataFC_36))

            const filtro = viveros.filter(anexo => anexo.baja !== null)
            const newProductos = []
            for (const i in filtro) {
                const { ...restProducto } = filtro[i]
                if (restProducto.isbaja != true) {
                    restProducto.baja = false
                }
                newProductos.push(restProducto)
            }
            await dispatch(editarViveros(newProductos))
        }

        if (values.tipoBaja == 'productormagueybaja') {
            setproductormagueyalta(false)
            let { ...dataFC_36 } = values
            dataFC_36.productormaguey = false
            dataFC_36.productormagueyaltabaja = false
            await setValores(dataFC_36)
            await dispatch(agregarFC_36(dataFC_36))

            const filtro = predios.filter(anexo => anexo.baja !== null)
            const newProductos = []
            for (const i in filtro) {
                const { ...restProducto } = filtro[i]
                if (restProducto.isbaja != true) {
                    restProducto.baja = true
                }
                newProductos.push(restProducto)
            }
            await dispatch(editarPredios(newProductos))
        }

        if (tipo == 'productormagueyalta') {
            setproductormagueyalta(true)
            let { ...dataFC_36 } = values
            dataFC_36.productormaguey = true
            dataFC_36.productormagueyaltabaja = true
            dataFC_36.actualizacionprediossi = true
            await setValores(dataFC_36)
            await dispatch(agregarFC_36(dataFC_36))

            const filtro = predios.filter(anexo => anexo.baja !== null)
            const newProductos = []
            for (const i in filtro) {
                const { ...restProducto } = filtro[i]
                if (restProducto.isbaja != true) {
                    restProducto.baja = false
                }
                newProductos.push(restProducto)
            }
            await dispatch(editarPredios(newProductos))
        }

        if (values.tipoBaja == 'productormezcalbaja') {
            setproductormezcalalta(false)
            let { ...dataFC_36 } = values
            dataFC_36.productormezcal = false
            dataFC_36.productormezcalaltabaja = false
            await setValores(dataFC_36)
            await dispatch(agregarFC_36(dataFC_36))
            const filtro = anexoInstalaciones.filter(anexo => anexo.data.baja !== null)// & anexo.data.tipoInstalacion != 'Unidad Producción' )

            const newProductos = []
            for (const i in filtro) {
                const { ...restProducto } = filtro[i].data
                if (restProducto.isbaja != true && restProducto.tipoInstalacion == 'Unidad Producción') {
                    restProducto.baja = true
                }
                if (!fc_36.envasador && restProducto?.tipoInstalacion == 'Unidad Almacén') {
                    if (restProducto?.dataSeccion?.granelAlmacen?.length > 0 || restProducto?.dataSeccion?.maduracionAlmacen?.length > 0) {
                        restProducto.baja = true
                    }
                }
                newProductos.push({ data: restProducto })
            }

            await dispatch(editarInstalacionBajaAlta(newProductos))
        }

        if (tipo == 'productormezcalalta') {
            setproductormezcalalta(true)
            let { ...dataFC_36 } = values
            dataFC_36.productormezcal = true
            dataFC_36.productormezcalaltabaja = true
            await setValores(dataFC_36)
            await dispatch(agregarFC_36(dataFC_36))
            //const filtro = anexoInstalaciones.filter(anexo => {anexo.baja !== null})

            const newProductos = []
            for (const i in anexoInstalaciones) {
                const { ...restProducto } = anexoInstalaciones[i].data
                if (restProducto.isbaja != true && restProducto.tipoInstalacion == 'Unidad Producción') {
                    restProducto.baja = false
                }
                if (restProducto?.tipoInstalacion == 'Unidad Almacén') {
                    if (restProducto?.dataSeccion?.granelAlmacen?.length > 0 || restProducto?.dataSeccion?.maduracionAlmacen?.length > 0) {
                        restProducto.baja = false
                    }
                }
                newProductos.push({ data: restProducto })
            }
            await dispatch(editarInstalacionBajaAlta(newProductos))
        }

        if (values.tipoBaja == 'envasadorbaja') {
            setenvasadoralta(false)
            let { ...dataFC_36 } = values
            dataFC_36.envasador = false
            dataFC_36.envasadoraltabaja = false
            await setValores(dataFC_36)
            await dispatch(agregarFC_36(dataFC_36))
            const filtro = anexoInstalaciones.filter(anexo => anexo.data.baja !== null)//&& anexo.data.tipoInstalacion == 'Unidad Envasado' )
            const newProductos = []
            for (const i in filtro) {
                const { ...restProducto } = filtro[i].data
                if (restProducto.isbaja != true && restProducto.tipoInstalacion == 'Unidad Envasado') {
                    restProducto.baja = true
                }
                if (!fc_36.productormezcal && restProducto?.tipoInstalacion == 'Unidad Almacén') {
                    if (restProducto?.dataSeccion?.granelAlmacen?.length > 0 || restProducto?.dataSeccion?.maduracionAlmacen?.length > 0) {
                        restProducto.baja = true
                    }
                }
                if ((!fc_36.comercializadorbebidas || !fc_36.comercializadormezcal) && restProducto?.tipoInstalacion == 'Unidad Almacén') {
                    if (restProducto?.dataSeccion?.equipoAlmacen?.length > 0) {
                        restProducto.baja = true
                    }
                }
                newProductos.push({ data: restProducto })
            }
            await dispatch(editarInstalacionBajaAlta(newProductos))
        }

        if (tipo == 'envasadoralta') {
            setenvasadoralta(true)
            let { ...dataFC_36 } = values
            dataFC_36.envasador = true
            dataFC_36.envasadoraltabaja = true
            dataFC_36.actualizacioninstalacionsi = true

            await setValores(dataFC_36)
            await dispatch(agregarFC_36(dataFC_36))

            const newProductos = []
            for (const i in anexoInstalaciones) {
                const { ...restProducto } = anexoInstalaciones[i].data
                if (restProducto.isbaja != true && restProducto.tipoInstalacion == 'Unidad Envasado') {
                    restProducto.baja = false
                }
                if ((!fc_36.comercializadorbebidas || !fc_36.comercializadormezcal) && restProducto?.tipoInstalacion == 'Unidad Almacén') {
                    if (restProducto?.dataSeccion?.equipoAlmacen?.length > 0) {
                        restProducto.baja = false
                    }
                }
                newProductos.push({ data: restProducto })
            }
            await dispatch(editarInstalacionBajaAlta(newProductos))
        }

        if (values.tipoBaja == 'comercializadormezcalbaja') {
            setcomercializadormezcalalta(false)
            let { ...dataFC_36 } = values
            dataFC_36.comercializadormezcal = false
            dataFC_36.comercializadormezcalaltabaja = false
            await setValores(dataFC_36)
            await dispatch(agregarFC_36(dataFC_36))

            const filtro = marcas.filter(anexo => anexo.baja !== null)
            const newProductos = []
            for (const i in filtro) {
                const { ...restProducto } = filtro[i]
                if (restProducto.isbaja != true) {
                    restProducto.baja = true
                }
                newProductos.push(restProducto)
            }
            await dispatch(editarMarcas(newProductos))
            const newProductosIns = []
            for (const i in anexoInstalaciones) {
                const { ...restProducto } = anexoInstalaciones[i].data
                if (!dataFC_36.envasador && !dataFC_36.comercializadorbebidas && restProducto?.tipoInstalacion == 'Unidad Almacén') {
                    if (restProducto?.dataSeccion?.equipoAlmacen?.length > 0) {
                        restProducto.baja = true
                    }
                }
                newProductosIns.push({ data: restProducto })
            }
            await dispatch(editarInstalacionBajaAlta(newProductosIns))
        }

        if (tipo == 'comercializadormezcalalta') {
            setcomercializadormezcalalta(true)
            let { ...dataFC_36 } = values
            dataFC_36.comercializadormezcal = true
            dataFC_36.comercializadormezcalaltabaja = true

            await setValores(dataFC_36)
            await dispatch(agregarFC_36(dataFC_36))

            const filtro = marcas.filter(anexo => anexo.baja !== null)
            const newProductos = []
            for (const i in filtro) {
                const { ...restProducto } = filtro[i]
                if (restProducto.isbaja != true) {
                    restProducto.baja = true
                }
                newProductos.push(restProducto)
            }
            await dispatch(editarMarcas(newProductos))
            const newProductosIns = []
            for (const i in anexoInstalaciones) {
                const { ...restProducto } = anexoInstalaciones[i].data
                if (!fc_36.envasador && !fc_36.comercializadorbebidas && restProducto?.tipoInstalacion == 'Unidad Almacén') {
                    if (restProducto?.dataSeccion?.equipoAlmacen?.length > 0) {
                        restProducto.baja = true
                    }
                }
                newProductosIns.push({ data: restProducto })
            }
        }

        if (values.tipoBaja == 'comercializadorbebidasbaja') {
            setcomercializadorbebidasalta(false)
            let { ...dataFC_36 } = values
            dataFC_36.comercializadorbebidas = false
            dataFC_36.comercializadorbebidasaltabaja = false
            await setValores(dataFC_36)
            await dispatch(agregarFC_36(dataFC_36))

            const filtro = marcasBebidas.filter(anexo => anexo.baja !== null)
            const newProductos = []
            for (const i in filtro) {
                const { ...restProducto } = filtro[i]
                if (restProducto.isbaja != true) {
                    restProducto.baja = true
                }
                newProductos.push(restProducto)
            }
            await dispatch(editarMarcasBebidas(newProductos))

            const newProductosIns = []
            for (const i in anexoInstalaciones) {
                const { ...restProducto } = anexoInstalaciones[i].data
                if (!dataFC_36.envasador && !dataFC_36.comercializadormezcal && restProducto?.tipoInstalacion == 'Unidad Almacén') {
                    if (restProducto?.dataSeccion?.equipoAlmacen?.length > 0) {
                        restProducto.baja = true
                    }
                }
                newProductosIns.push({ data: restProducto })
            }
            await dispatch(editarInstalacionBajaAlta(newProductosIns))
        }

        if (tipo == 'comercializadorbebidasalta') {
            setcomercializadorbebidasalta(true)
            let { ...dataFC_36 } = values
            dataFC_36.comercializadorbebidas = true
            dataFC_36.comercializadorbebidasaltabaja = true
            await setValores(dataFC_36)
            await dispatch(agregarFC_36(dataFC_36))

            const filtro = marcasBebidas.filter(anexo => anexo.baja !== null)
            const newProductos = []
            for (const i in filtro) {
                const { ...restProducto } = filtro[i]
                if (restProducto.isbaja != true) {
                    restProducto.baja = false
                }
                newProductos.push(restProducto)
            }
            await dispatch(editarMarcasBebidas(newProductos))
            const newProductosIns = []
            for (const i in anexoInstalaciones) {
                const { ...restProducto } = anexoInstalaciones[i].data
                if (restProducto?.tipoInstalacion == 'Unidad Almacén') {
                    if (restProducto?.dataSeccion?.equipoAlmacen?.length > 0) {
                        restProducto.baja = false
                    }
                }
                newProductosIns.push({ data: restProducto })
            }
        }
        /*if (tipo == 'comercializadorbebidasalta' || tipo == 'comercializadormezcalalta') {
            const newProductos = []
            for (const i in anexoInstalaciones) {
                const { ...restProducto } = anexoInstalaciones[i].data
                if (restProducto.isbaja != true && restProducto.tipoInstalacion == 'Unidad Almacén') {
                    restProducto.baja = false
                }
                newProductos.push({ data: restProducto })
            }
            await dispatch(editarInstalacionBajaAlta(newProductos))
        }*/
        /*if (values.tipoBaja == 'comercializadorbebidasbaja' && values.tipoBaja == 'comercializadormezcalbaja') {

            const newProductos = []
            for (const i in anexoInstalaciones) {
                const { ...restProducto } = anexoInstalaciones[i].data
                if (restProducto.isbaja != true && restProducto.tipoInstalacion == 'Unidad Almacén') {
                    restProducto.baja = true
                }
                if (!fc_36.envasador  && restProducto?.tipoInstalacion == 'Unidad Almacén') {
                    if (restProducto?.dataSeccion?.equipoAlmacen?.length > 0 ) {
                        restProducto.baja = true
                    }
                }
                newProductos.push({ data: restProducto })
            }
            await dispatch(editarInstalacionBajaAlta(newProductos))
        }*/
        handleCloseModalBaja()
    }

    const marcasbaja = async (value) => {
        if (value) {
            let newProductos = []
            let newProductos1 = []
            for (const i in marcas) {
                const { ...restProducto } = marcas[i]
                if (restProducto.idmarcascliente != null || restProducto.idmarcascliente != undefined) restProducto.baja = true
                newProductos.push(restProducto)
            }
            await dispatch(editarMarcas(newProductos))
            for (const i in marcasBebidas) {
                const { ...restProducto } = marcasBebidas[i]
                if (restProducto.idmarcasproductocliente != null || restProducto.idmarcasproductocliente != undefined) restProducto.baja = true
                newProductos1.push(restProducto)
            }
            await dispatch(editarMarcasBebidas(newProductos1))
        } else {
            let newProductos = []
            let newProductos1 = []
            for (const i in marcas) {
                const { ...restProducto } = marcas[i]
                if (restProducto.idmarcascliente != null || restProducto.idmarcascliente != undefined) restProducto.baja = false
                newProductos.push(restProducto)
            }
            await dispatch(editarMarcas(newProductos))
            for (const i in marcasBebidas) {
                const { ...restProducto } = marcasBebidas[i]
                if (restProducto.idmarcasproductocliente != null || restProducto.idmarcasproductocliente != undefined) restProducto.baja = false
                newProductos1.push(restProducto)
            }
            await dispatch(editarMarcasBebidas(newProductos1))
        }

    }
    const representantesLegalesValidacion = async (value) => {
        if (value == 'fisica') {
            const filtro = responsablesLegales.findIndex(anexo => anexo.principal == true)
            const filtroPrincipal = responsablesLegales.findIndex(anexo => anexo.principal == true && anexo.baja == null)

            const newProductos = []
            for (const i in responsablesLegales) {
                const { ...restProducto } = responsablesLegales[i]
                newProductos.push(restProducto)
            }
            if (newProductos[Number(filtro)].baja == true) newProductos[Number(filtro)].baja = true
            else newProductos[Number(filtro)].baja = true

            if (filtroPrincipal != -1) newProductos[Number(filtroPrincipal)].principal = false

            await dispatch(editarRepresentanteLegal(newProductos))
        }
        if (value == 'moral') {
            const filtro = responsablesLegales.findIndex(anexo => anexo.principal == true && anexo?.baja != null)
            const filtroPrincipal = responsablesLegales.findIndex(anexo => anexo.principal == true && anexo.baja == null)

            const newProductos = []
            for (const i in responsablesLegales) {
                const { ...restProducto } = responsablesLegales[i]
                newProductos.push(restProducto)
            }
            if (newProductos[Number(filtro)].baja == true) newProductos[Number(filtro)].baja = false
            else newProductos[Number(filtro)].baja = false

            if (filtroPrincipal != -1) newProductos[Number(filtroPrincipal)].principal = false

            await dispatch(editarRepresentanteLegal(newProductos))
        }
    }




    const validation = values => {
        let errores = {};
        const textoCheck = 'Debe de seleccionar al menos una opción'
        const texto = 'Campo Obligatorio'
        if (nombresParaPaginas[paginaActiva - 1] === 'Datos generales') {
            if (values.numerohombres < 0 && values.cambiorazon) errores.numero = 'error con el numero'
            if (values.numeromujeres < 0 && values.cambiorazon) errores.numero = 'error con el numero'
            if (values.numerodiscapacitados < 0 && values.cambiorazon) errores.numero = 'error con el numero'
            if (values.numerobase < 0 && values.cambiorazon) errores.numero = 'error con el numero'
            if (values.numeroeventuales < 0 && values.cambiorazon) errores.numero = 'error con el numero'
            if (values.actualizacionnombrerazon === dataCliente.nombrerazonsocial && values.tipoempresa == 'fisica' && values.cambiorazon) { errores.actualizacionnombrerazon = 'Campo obligatorio para actualizar' }
            if (values.rfc === dataCliente.rfc && values.tipoempresa == 'fisica' && values.cambiorazon) { errores.rfc = 'Campo obligatorio para actualizar' }
            if (!values.cambiorazon && !values.actualizacioncadena && !values.actualizaciondomicilio &&
                !values.cambioresponsable && !values.cambiorepresentante && !values.actualizarmedioscontacto &&
                !values.cambioresponsableinst && !values.actualizarmarcas && !values.actualizacionprediosviveros &&
                !values.actualizacioninstalaciones) errores.seleccion = 'seleccione un campo'
            if (values.actualizaciondomicilio) {
                let filtro = domicilio.filter(anexo => anexo.domicilioprincipal === true)
                if (filtro.length == 0) {
                    errores.domicilios = 'Debe de seleccionar un domicilio fical'
                }
            }
            if (values.cambioresponsable) {
                let filtroRepBaja = responsablesLegales.filter(anexo => anexo.principal == true && anexo.baja == true)
                let filtroRepAlta = responsablesLegales.filter(anexo => anexo.principal == true && anexo.alta == true)

                if (filtroRepBaja.length > 0 && filtroRepAlta.length == 0 && values.tipoempresa != 'fisica') {
                    errores.responsable = 'Al dar de baja un responsable debe de dar de alta uno nuevo'
                }
            }
            if (values.cambiorazon) {
                if (values.rfc == dataCliente.rfc) errores.rfc = 'Cambiar el RFC'
                if (values.actualizacionnombrerazon == dataCliente.nombrerazonsocial) errores.razonsocial = 'Cambiar el nombre o razón social'
                if (!values.medioscontactosi && !values.medioscontactono) errores.mediosContacto = 'Seleccionar una opcion'
                if (!values.repesentantelegalsi && !values.repesentantelegalno) errores.mediosContacto = 'Seleccionar una opcion'
                if (!values.personaautorizadasi && !values.personaautorizadano) errores.mediosContacto = 'Seleccionar una opcion'
                if (!values.domiciliofiscalsi && !values.domiciliofiscalno) errores.mediosContacto = 'Seleccionar una opcion'

            }
            //if (values.actualizacionnombrerazon == dataCliente.nombrerazonsocial && values.tipoempresa == 'fisica') { errores.actualizacionnombrerazon = 'Campo obligatorio para actualizar' }

        }
        if (nombresParaPaginas[paginaActiva - 1] === 'Predios/Viveros' && values.cambiorazon) {
            if (fc_36.actualizacionprediossi && fc_36.actualizacionprediosno) errores.predios = 'Seleccionar una opción'
            if (fc_36.actualizacionviverossi && fc_36.actualizacionviverosno) errores.viveros = 'Seleccionar una opción'
        }
        if (nombresParaPaginas[paginaActiva - 1] === 'Instalaciones') {
            if (fc_36.productormezcal) {
                let filtroInstalacion = anexoInstalaciones.filter(anexo => anexo.data.tipoInstalacion == 'Unidad Producción' && anexo.data.baja == false)
                if (filtroInstalacion.length == 0) errores.errorInstalacion = 'Nota: no puede dar de baja todas sus unidades de producción'
            }
            if (fc_36.envasador) {
                let filtroInstalacion = anexoInstalaciones.filter(anexo => anexo.data.tipoInstalacion == 'Unidad Envasado' && anexo.data.baja == false)
                if (filtroInstalacion.length == 0) errores.errorInstalacion = 'Nota: no puede dar de baja todas sus unidades de producción'
            }
        }
        if (nombresParaPaginas[paginaActiva - 1] === 'Marcas' && (values.cambiorazon || values.actualizacioncadena)) {
            let filtromarcas = marcas.filter(anexo => anexo.alta == true)
            let filtromarcasbebidas = marcasBebidas.filter(anexo => anexo.alta == true)
            if (values.comercializadormezcal && filtromarcas.length == 0 && values.comercializadormezcalaltabaja) errores.marca = 'agregar marcas para actualizacion'
            if (values.comercializadorbebidas && filtromarcasbebidas.length == 0 && values.comercializadorbebidasaltabaja) errores.marca = 'agregar marcas para actualizacion'
            if (values.actualizacioncadena && !values.cambiorazon) {
                if (values.comercializadorbebidasalta && values.comercializadorbebidas && marcasBebidas.length == 0) errores.marca = 'agregar marcas para actualizacion'
                if (values.comercializadormezcalaltabaja && values.comercializadormezcal && marcas.length == 0) errores.marca = 'agregar marcas para actualizacion'
            }
        }
        if (nombresParaPaginas[paginaActiva - 1] === 'Responsables de Instalaciones') {
            for (const i in responsableInst) {
                let responsableInstalacion = responsableInst[i]
                if (responsableInstalacion.baja == true) {
                    let filtroResponsable = responsableInst.filter(anexo => (anexo.alias == responsableInstalacion.alias && (anexo.baja == false || anexo.baja == null)))
                    if (filtroResponsable.length == 0) errores.reponsableInstalaciones = 'Ingresar por lo menos un resposable'
                }
            }

        }
        return errores;
    }
    const [openModalPregunta, setOpenModalPregunta] = React.useState(false);
    const [accionPregunta, setAccionPregunta] = React.useState('')
    const handleOpenModalPregunta = (data) => {
        setAccion(data?.accion)
        setOpenModalPregunta(true)
    }
    const handleCloseModalPregunta = () => {
        setAccionPregunta('')
        setOpenModalPregunta(false)
    }
    const [res1, setres1] = useState(false)

    const modalComponentPregunta = () => {
        return (
            <div>
                <Modal
                    open={openModalPregunta}
                    onClose={handleCloseModalPregunta}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>¿Que servicio desea realizar?</center>
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2, textAlign: 'justify' }} component="h2">
                            <input className={`ms-2 mt-2 form-check-input `}
                                type="checkbox" onChange={e => { setres1(e.target.checked) }}
                                name="res1"
                                checked={res1} id="si" />
                            numero 1  <br />
                            <input className={`ms-2 mt-2 form-check-input `}
                                type="checkbox" onChange={e => { setres1(e.target.checked) }}
                                name="res1"
                                checked={res1} id="si" />
                            numero 1
                            <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-success' onClick={() => {
                                switch (accion) {
                                    case 'eliminarAnexo':
                                        break;
                                    default:
                                        break;
                                }
                            }
                            }>CONTINUAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }
    return (
        <Fragment>
            <Formik
                enableReinitialize={true}
                initialValues={fc_36}
                validate={(valores) => {
                    //setValores(valores),
                    guardarActividadesEmpresa(), guardarDatos(valores)
                    validation
                }}
                onSubmit={(valores) => {
                    if (botonEnviarBorrador) {
                        enviarBorrador(valores)
                    }
                    if (botonEnviarRegistro) {
                        botonRegistrarFC_36(valores)
                    }
                    if (botonEnviarCorrecciones) {
                        enviarCorreccion(valores)
                    }
                }}
            >
                {({ values, handleChange, handleSubmit, handleBlur, errors, touched, resetForm, submitForm, setValues }) => (
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className='container2'>
                            <div className='row'>
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-12 marginsitoTop">
                                    <InfoBar nombreSolicitud={'Solicitud de actualización'} />
                                </div>
                                {!modoCorreccion &&
                                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center marginsitoTop">
                                        <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                            aria-label="Guardar cambios" aria-haspopup="true" onClick={() =>
                                                botonGuardarComoBorrador(values)} >
                                            <SaveIcon />
                                            {modoEdicionBorrador ?
                                                <div className="badge text-dark textoNormal textoModal">
                                                    Guardar cambios en borrador
                                                </div> :
                                                <div className="badge text-dark textoNormal textoModal">
                                                    Guardar como borrador
                                                </div>

                                            }
                                        </IconButton>
                                    </div>
                                }
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 text-center ">
                                    <h1 ></h1>
                                </div>
                                {!modoCorreccion &&
                                    <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 text-center marginsitoTop">
                                        <Fragment>
                                            <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                                aria-label="Reiniciar formato" aria-haspopup="true" color="error" onClick={() =>
                                                    botonReiniciarFormato()}
                                            >
                                                <FormatClearIcon />
                                                <div className="badge text-dark textoNormal text-center textoModal">Reiniciar Formato</div>
                                            </IconButton>
                                        </Fragment>
                                    </div>
                                }
                            </div>
                            {paginaActiva === 1 ?
                                <div>
                                    <div className='row justify-content-start'>
                                        <div className='row'>
                                            <h6 className='text-center labelNaranja'>LA EMPRESA A TRAVÉS DE SU REPRESENTANTE SOLICITA LA ACTUALIZACIÓN DE</h6>
                                        </div>
                                        <div className={`row  ${estilos.divSoloBorderNaranja}`}>

                                            <div className={values.cambiorazon ? 'text-center' : 'col-md-4'} align='justify'>
                                                <input className={`form-check-input me-1 ${fc_36Map.cambiorazoncheck !== undefined ? (
                                                    fc_36Map?.cambiorazoncheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                    checked={values.cambiorazon} id='cambiorazon'
                                                    name="cambiorazon"
                                                    onChange={e => {
                                                        const { ...newValues } = values
                                                        newValues.cambiorazon = e.target.checked
                                                        newValues.actualizaciondomicilio = e.target.checked
                                                        newValues.cambioresponsable = e.target.checked
                                                        newValues.cambiorepresentante = e.target.checked
                                                        newValues.actualizarmedioscontacto = e.target.checked
                                                        newValues.actualizacioncadena = e.target.checked
                                                        newValues.cambioresponsableinst = false
                                                        newValues.actualizacioninstalaciones = e.target.checked
                                                        newValues.actualizacionprediosviveros = e.target.checked
                                                        newValues.actualizarmarcas = e.target.checked

                                                        newValues.medioscontactosi = false
                                                        newValues.repesentantelegalsi = false
                                                        newValues.personaautorizadasi = false
                                                        newValues.domiciliofiscalsi = false
                                                        newValues.actualizacionprediossi = false
                                                        newValues.actualizacionviverossi = false
                                                        newValues.actualizacioninstalacionsi = false
                                                        setActualizarMarca(e.target.checked)
                                                        setcambioresponsableinst(false)
                                                        setactualizacioncadena(e.target.checked)
                                                        setactualizarmedioscontacto(e.target.checked)
                                                        setcambiorepresentante(e.target.checked)
                                                        setcambioresponsable(e.target.checked)
                                                        setactualizaciondomicilio(e.target.checked)
                                                        setcambiorazon(e.target.checked)
                                                        setActualizarInstalaciones(e.target.checked)
                                                        setActualizarPrediosViveros(e.target.checked)
                                                        setValues(newValues)
                                                        marcasbaja(e.target.value)
                                                    }}
                                                    onBlur={handleBlur}
                                                />

                                                <Tooltip position='top' title='Podrá realizar cambios de razón social o régimen fiscal, conservando su número de asociado actual.'>
                                                    <label className="form-check-label" htmlFor="flexCheckChecked">
                                                        <small>Cambio de razón social o régimen fiscal </small>
                                                    </label>
                                                </Tooltip>
                                                <span className='text-danger'>{fc_36Map?.cambiorazoncheck ? fc_36Map?.cambiorazon : ''}</span>
                                            </div>
                                            {values.cambiorazon === false &&
                                                <Fragment>
                                                    <div className='col-md-4' align='justify'>
                                                        <input className={`form-check-input me-1 ${fc_36Map.actualizacioncadenacheck !== undefined ? (
                                                            fc_36Map?.actualizacioncadenacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                            checked={values.actualizacioncadena} id='actualizacioncadena'
                                                            name="actualizacioncadena"
                                                            onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.actualizacioncadena = e.target.checked
                                                                setactualizacioncadena(e.target.checked)
                                                                newValues.actualizaciondomicilio = false
                                                                newValues.cambioresponsable = false
                                                                newValues.cambiorepresentante = false
                                                                newValues.actualizarmedioscontacto = false
                                                                newValues.cambioresponsableinst = false
                                                                newValues.actualizarmarcas = false
                                                                newValues.actualizacioninstalaciones = false
                                                                newValues.actualizacionprediosviveros = false
                                                                setActualizarMarca(false)
                                                                setcambioresponsableinst(false)
                                                                setActualizarInstalaciones(false)
                                                                setActualizarPrediosViveros(false)
                                                                setValues(newValues)
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                        <Tooltip position='top' title='Podrá darse de baja o alta en cualquier eslabón de la cadena productiva Maguey-Mezcal.'>
                                                            <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                <small>Actualización de cadena</small>
                                                            </label>
                                                        </Tooltip>
                                                        <br />
                                                        <label className="form-check-label ms-3" htmlFor="flexCheckChecked">
                                                            <small>productiva</small>
                                                        </label>
                                                        <span className='text-danger'>{fc_36Map?.actualizacioncadenacheck ? fc_36Map?.actualizacioncadena : ''}</span>
                                                    </div>
                                                    <div className='col-md-4' align='justify'>
                                                        <input className={`form-check-input me-1 ${fc_36Map.actualizaciondomiciliocheck !== undefined ? (
                                                            fc_36Map?.actualizaciondomiciliocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                            checked={values.actualizaciondomicilio} id='actualizaciondomicilio'
                                                            name="actualizaciondomicilio"
                                                            onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.actualizaciondomicilio = e.target.checked
                                                                newValues.domiciliofiscalsi = e.target.checked
                                                                setactualizaciondomicilio(e.target.checked)
                                                                newValues.actualizacioncadena = false
                                                                newValues.cambioresponsable = false
                                                                newValues.cambiorepresentante = false
                                                                newValues.actualizarmedioscontacto = false
                                                                newValues.cambioresponsableinst = false
                                                                newValues.actualizarmarcas = false
                                                                newValues.actualizacioninstalaciones = false
                                                                newValues.actualizacionprediosviveros = false
                                                                newValues.personaautorizadasi = false
                                                                newValues.repesentantelegalsi = false
                                                                newValues.medioscontactosi = false
                                                                setActualizarMarca(false)
                                                                setcambioresponsableinst(false)
                                                                setActualizarInstalaciones(false)
                                                                setActualizarPrediosViveros(false)
                                                                setValues(newValues)
                                                            }}
                                                            onBlur={handleBlur}
                                                        />

                                                        <Tooltip position='top' title='Podrá hacer el cambio de su domicilio fiscal, así como agregar o dar de baja sucursales fiscales.'>
                                                            <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                <small>Actualización de domicilio fiscal</small>
                                                            </label>
                                                        </Tooltip>
                                                        <span className='text-danger'>{fc_36Map?.actualizaciondomiciliocheck ? fc_36Map?.actualizaciondomicilio : ''}</span>
                                                    </div>
                                                    <div className='col-md-4' align='justify'>
                                                        <input className={`form-check-input me-1 ${fc_36Map.cambioresponsablecheck !== undefined ? (
                                                            fc_36Map?.cambioresponsablecheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                            checked={values.cambioresponsable} id='cambioresponsable'
                                                            name="cambioresponsable"
                                                            onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.cambioresponsable = e.target.checked
                                                                newValues.repesentantelegalsi = e.target.checked
                                                                setcambioresponsable(e.target.checked)
                                                                newValues.actualizaciondomicilio = false
                                                                newValues.actualizacioncadena = false
                                                                newValues.cambiorepresentante = false
                                                                newValues.actualizarmedioscontacto = false
                                                                newValues.cambioresponsableinst = false
                                                                newValues.actualizarmarcas = false
                                                                newValues.actualizacioninstalaciones = false
                                                                newValues.actualizacionprediosviveros = false
                                                                newValues.personaautorizadasi = false
                                                                newValues.domiciliofiscalsi = false
                                                                newValues.medioscontactosi = false
                                                                setActualizarMarca(false)
                                                                setcambioresponsableinst(false)
                                                                setActualizarInstalaciones(false)
                                                                setActualizarPrediosViveros(false)
                                                                setValues(newValues)
                                                            }}
                                                            onBlur={handleBlur}
                                                        />

                                                        <Tooltip position='top' title='Podrá hacer el cambio de su representante legal, así como agregar o dar de baja apoderados legales, en su caso.'>
                                                            <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                <small>Actualización de representante legal</small>
                                                            </label>
                                                        </Tooltip>
                                                        <span className='text-danger'>{fc_36Map?.cambioresponsablecheck ? fc_36Map?.cambioresponsable : ''}</span>
                                                    </div>

                                                    <div className='col-md-4' align='justify'>
                                                        <input className={`form-check-input me-1 ${fc_36Map.cambiorepresentantecheck !== undefined ? (
                                                            fc_36Map?.cambiorepresentante ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                            checked={values.cambiorepresentante} id='cambiorepresentante'
                                                            name="cambiorepresentante"
                                                            onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.cambiorepresentante = e.target.checked
                                                                newValues.personaautorizadasi = e.target.checked
                                                                setcambiorepresentante(e.target.checked)
                                                                newValues.cambioresponsable = false
                                                                newValues.actualizaciondomicilio = false
                                                                newValues.actualizacioncadena = false
                                                                newValues.actualizarmedioscontacto = false
                                                                newValues.cambioresponsableinst = false
                                                                newValues.actualizarmarcas = false
                                                                newValues.actualizacioninstalaciones = false
                                                                newValues.actualizacionprediosviveros = false
                                                                newValues.medioscontactosi = false
                                                                newValues.repesentantelegalsi = false
                                                                newValues.domiciliofiscalsi = false
                                                                setActualizarMarca(false)
                                                                setcambioresponsableinst(false)
                                                                setActualizarInstalaciones(false)
                                                                setActualizarPrediosViveros(false)
                                                                setValues(newValues)
                                                            }}
                                                            onBlur={handleBlur}
                                                        />

                                                        <Tooltip position='top' title='Podrá agregar o dar de baja personas autorizadas para que realicen trámites(recolección de hologramas, entrega de documentación, ingreso de solicitudes, etc) a nombre de su razón social.'>
                                                            <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                <small>Actualización de persona </small>
                                                            </label>
                                                        </Tooltip>

                                                        <br />
                                                        <label className="form-check-label ms-3" htmlFor="flexCheckChecked">
                                                            <small> autorizada para trámite</small>
                                                        </label>
                                                        <span className='text-danger'>{fc_36Map?.cambiorepresentantecheck ? fc_36Map?.cambiorepresentante : ''}</span>
                                                    </div>
                                                    <div className='col-md-4' align='justify'>
                                                        <input className={`form-check-input me-1 ${fc_36Map.medioscontactocheck !== undefined ? (
                                                            fc_36Map?.medioscontactocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                            checked={values.actualizarmedioscontacto} id='actualizarmedioscontacto'
                                                            name="actualizarmedioscontacto"
                                                            onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.actualizarmedioscontacto = e.target.checked
                                                                newValues.medioscontactosi = e.target.checked
                                                                setactualizarmedioscontacto(e.target.checked)
                                                                newValues.cambiorepresentante = false
                                                                newValues.cambioresponsable = false
                                                                newValues.actualizaciondomicilio = false
                                                                newValues.actualizacioncadena = false
                                                                newValues.cambioresponsableinst = false
                                                                newValues.actualizarmarcas = false
                                                                newValues.actualizacioninstalaciones = false
                                                                newValues.actualizacionprediosviveros = false
                                                                newValues.personaautorizadasi = false
                                                                newValues.repesentantelegalsi = false
                                                                newValues.domiciliofiscalsi = false
                                                                setActualizarMarca(false)
                                                                setcambioresponsableinst(false)
                                                                setActualizarInstalaciones(false)
                                                                setActualizarPrediosViveros(false)
                                                                setValues(newValues)
                                                            }}
                                                            onBlur={handleBlur}
                                                        />

                                                        <Tooltip position='top' title='Podrá dar de alta o baja algún número telefónico y/o correo electrónico para recibir información.'>
                                                            <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                <small>Actualización medios de contacto</small>
                                                            </label>
                                                        </Tooltip>
                                                        <span className='text-danger'>{fc_36Map?.actualizarmedioscontactocheck ? fc_36Map?.actualizarmedioscontacto : ''}</span>
                                                    </div>
                                                    <div className='col-md-4' align='justify'>
                                                        <input className={`form-check-input me-1 ${fc_36Map.cambioresponsableinstcheck !== undefined ? (
                                                            fc_36Map?.cambioresponsableinstcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                            checked={values.cambioresponsableinst} id='cambioresponsableinst'
                                                            name="cambioresponsableinst"
                                                            onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.cambioresponsableinst = e.target.checked
                                                                setcambioresponsableinst(e.target.checked)
                                                                newValues.actualizarmedioscontacto = false
                                                                newValues.cambiorepresentante = false
                                                                newValues.cambioresponsable = false
                                                                newValues.actualizaciondomicilio = false
                                                                newValues.actualizacioncadena = false
                                                                newValues.actualizarmarcas = false
                                                                newValues.actualizacioninstalaciones = false
                                                                newValues.actualizacionprediosviveros = false
                                                                setActualizarMarca(false)
                                                                setcambioresponsableinst(false)
                                                                setActualizarInstalaciones(false)
                                                                setActualizarPrediosViveros(false)
                                                                setValues(newValues)
                                                            }}
                                                            onBlur={handleBlur} />

                                                        <Tooltip position='top' title='Podrá agregar o dar de baja a los responsables de sus instalaciones activas.'>
                                                            <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                <small>Actualización de responsables de</small>
                                                            </label>
                                                        </Tooltip>

                                                        <br />
                                                        <label className="form-check-label ms-3" htmlFor="flexCheckChecked">
                                                            <small>instalaciones</small>
                                                        </label>
                                                        <span className='text-danger'>{fc_36Map?.cambioresponsableinstcheck ? fc_36Map?.cambioresponsableinst : ''}</span>
                                                    </div>
                                                    {(dataCliente.comercializadorbebidasmezcal || dataCliente.comercializadormezcal) &&
                                                        <div className='col-md-4' align='justify'>
                                                            <input className={`form-check-input me-1 ${fc_36Map.otrocheck !== undefined ? (
                                                                fc_36Map?.otrocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                                checked={values.actualizarmarcas} id='actualizarmarcas'
                                                                name="actualizarmarcas"
                                                                onChange={e => {
                                                                    const { ...newValues } = values
                                                                    newValues.actualizarmarcas = e.target.checked
                                                                    setActualizarMarca(e.target.checked)
                                                                    setcambioresponsableinst(false)
                                                                    newValues.cambioresponsableinst = false
                                                                    newValues.actualizarmedioscontacto = false
                                                                    newValues.cambiorepresentante = false
                                                                    newValues.cambioresponsable = false
                                                                    newValues.actualizaciondomicilio = false
                                                                    newValues.actualizacioncadena = false
                                                                    newValues.actualizacioninstalaciones = false
                                                                    newValues.actualizacionprediosviveros = false
                                                                    setActualizarInstalaciones(false)
                                                                    setActualizarPrediosViveros(false)
                                                                    setValues(newValues)
                                                                }}
                                                                onBlur={handleBlur}
                                                            />

                                                            <Tooltip position='top' title='Podrá realizar el alta o baja de marcas.'>
                                                                <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                    <small>Actualización de marcas</small>
                                                                </label>
                                                            </Tooltip>
                                                            <span className='text-danger'>{fc_36Map?.otrocheck ? fc_36Map?.otro : ''}</span>
                                                        </div>
                                                    }
                                                    {(dataCliente.productormezcal || dataCliente.envasador || dataCliente.comercializadorbebidasmezcal || dataCliente.comercializadormezcal) &&
                                                        <div className='col-md-4' align='justify'>
                                                            <input className={`form-check-input me-1 ${fc_36Map.actualizacioninstalacionescheck !== undefined ? (
                                                                fc_36Map?.actualizacioninstalacionescheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                                checked={values.actualizacioninstalaciones} id='actualizacionInstalaciones'
                                                                name="actualizacioninstalaciones"
                                                                onChange={e => {
                                                                    const { ...newValues } = values
                                                                    newValues.actualizacioninstalaciones = e.target.checked
                                                                    newValues.actualizacioninstalacionsi = e.target.checked
                                                                    newValues.actualizarmarcas = false
                                                                    setActualizarMarca(false)
                                                                    setcambioresponsableinst(false)
                                                                    newValues.cambioresponsableinst = false
                                                                    newValues.actualizarmedioscontacto = false
                                                                    newValues.cambiorepresentante = false
                                                                    newValues.cambioresponsable = false
                                                                    newValues.actualizaciondomicilio = false
                                                                    newValues.actualizacioncadena = false
                                                                    newValues.actualizacionprediosviveros = false
                                                                    setActualizarInstalaciones(e.target.checked)
                                                                    setActualizarPrediosViveros(false)
                                                                    guardarActividadesEmpresa()
                                                                    setValues(newValues)
                                                                }}
                                                                onBlur={handleBlur}
                                                            />

                                                            <Tooltip position='top' title='Podrá dar de alta o baja fábricas,envasadoras y/o almacénes que correspondan a los eslabónes actualmente activos.'>
                                                                <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                    <small>Alta o baja instalaciones</small>
                                                                </label>
                                                            </Tooltip>
                                                            <span className='text-danger'>{fc_36Map?.actualizacioninstalacionescheck ? fc_36Map?.actualizacioninstalaciones : ''}</span>
                                                        </div>
                                                    }
                                                    {(dataCliente.viverista || dataCliente.productormaguey) &&
                                                        <div className='col-md-4' align='justify'>
                                                            <input className={`form-check-input me-1 ${fc_36Map.actualizacionprediosviveroscheck !== undefined ? (
                                                                fc_36Map?.actualizacionprediosviveroscheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                                checked={values.actualizacionprediosviveros} id='actualizacionprediosviveros'
                                                                name="actualizacionprediosviveros"
                                                                onChange={e => {
                                                                    const { ...newValues } = values
                                                                    newValues.actualizacionprediosviveros = e.target.checked

                                                                    if (dataCliente.productormaguey) newValues.actualizacionprediossi = true
                                                                    else newValues.actualizacionprediossi = false

                                                                    if (dataCliente.viverista) newValues.actualizacionviverossi = true
                                                                    else newValues.actualizacionviverossi = false

                                                                    newValues.actualizacioninstalaciones = false
                                                                    newValues.actualizarmarcas = false
                                                                    setActualizarMarca(false)
                                                                    setcambioresponsableinst(false)
                                                                    newValues.cambioresponsableinst = false
                                                                    newValues.actualizarmedioscontacto = false
                                                                    newValues.cambiorepresentante = false
                                                                    newValues.cambioresponsable = false
                                                                    newValues.actualizaciondomicilio = false
                                                                    newValues.actualizacioncadena = false
                                                                    setActualizarInstalaciones(false)
                                                                    setActualizarPrediosViveros(e.target.checked)
                                                                    setValues(newValues)
                                                                }} onBlur={handleBlur}
                                                            />

                                                            <Tooltip position='top' title='Podrá dar de baja predios y/o viveros registrados, si desea registrar un nuevo predio y/o vivero deberá dirigirse al apartado: Registro de maguey.'>
                                                                <label className="form-check-label" htmlFor="flexCheckChecked">
                                                                    <small>Baja predios/viveros</small>
                                                                </label>
                                                            </Tooltip>
                                                            <span className='text-danger'>{fc_36Map?.actualizacionprediosviveroscheck ? fc_36Map?.actualizacionprediosviveros : ''}</span>
                                                        </div>
                                                    }

                                                </Fragment>}
                                        </div>

                                    </div> <br />
                                    {values.cambiorazon &&
                                        <Fragment>
                                            <div className='row'>
                                                <h6 className='text-center labelNaranja'>CAMBIO DE RAZÓN SOCIAL O REGIMEN FISCAL</h6>
                                            </div>
                                            <div className='row justify-content-start'>
                                                <div className='col-md-4 mt-2'>
                                                    <h5 className={`${estilos.textoPregunta}`}>Tipo de empresa a cambiar</h5>
                                                </div>
                                                <div className={`form-floating mb-3 ${(values.tipoempresa === 'fisica' || values.tipoempresa === 'moral') ? 'col-md-4' : 'col-md-8'}`}>
                                                    <select className={`form-select form-select-sm ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ''}`}
                                                        name="tipoempresa" value={values.tipoempresa} onBlur={handleBlur}
                                                        //onChange={handleChange}
                                                        onChange={e => {
                                                            const { ...newValues } = values
                                                            newValues.tipoempresa = e.target.value
                                                            setValues(newValues)
                                                            representantesLegalesValidacion(e.target.value)
                                                        }} >
                                                        <option value="">Seleccione una opción</option>
                                                        <option value="fisica">Persona Física</option>
                                                        <option value="moral">Persona Moral</option>
                                                    </select>
                                                    {touched.tipoempresa && errors.tipoempresa && <div className="text-danger">{errors.tipoempresa}</div>}
                                                    {/* <span className='text-danger'>{fc_36Map?.sexo}</span> */}
                                                    {/* <label className='ms-2'>Tipo de empresa</label> */}
                                                </div>
                                                {(values.tipoempresa === 'fisica' || values.tipoempresa === 'moral') &&
                                                    <Fragment>
                                                        <div className='col-md-4'>
                                                            <div className="form-floating mb-3">
                                                                <input type="text" className={`form-control ${fc_36Map.rfccheck !== undefined ? (
                                                                    fc_36Map?.rfccheck ? 'inputDenegado' : 'inputValidado') : dataCliente.rfc == values.rfc ? 'inputDenegado' : ''}`} id="floatingInput"
                                                                    placeholder='RFC' value={values.rfc}
                                                                    //onChange={handleChange}
                                                                    onChange={e => {
                                                                        const { ...newValues } = values
                                                                        newValues.rfc = e.target.value?.toUpperCase()
                                                                        setValues(newValues)
                                                                    }}
                                                                    name="rfc" onBlur={handleBlur} />
                                                                <label htmlFor='floatingInput'>RFC</label>
                                                                <span className='text-danger'>{fc_36Map?.rfc}</span>
                                                                <div className="text-danger">{dataCliente.rfc == values.rfc ? 'Campo obligatorio para actualizar' : ''}</div>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-12'>
                                                            <div className="form-floating mb-3">
                                                                <input type="text" className={`form-control ${fc_36Map.actualizacionnombrerazoncheck !== undefined ? (
                                                                    fc_36Map?.actualizacionnombrerazoncheck ? 'inputDenegado' : 'inputValidado') :
                                                                    dataCliente.nombrerazonsocial == values.actualizacionnombrerazon ? 'inputDenegado' : ''}`}
                                                                    id="floatingInput" placeholder='Nombre o razón social'
                                                                    value={values.actualizacionnombrerazon} onChange={handleChange}
                                                                    name="actualizacionnombrerazon" onBlur={handleBlur} />
                                                                <label htmlFor='floatingInput'>Nombre o razón social/Régimen fiscal</label>
                                                                <span className='text-danger'>{fc_36Map?.actualizacionnombrerazon}</span>
                                                                <div className="text-danger">{dataCliente.nombrerazonsocial == values.actualizacionnombrerazon ? 'Campo obligatorio para actualizar' : ''}</div>

                                                            </div>
                                                        </div>
                                                    </Fragment>
                                                }
                                            </div>
                                            <h4 className='text-center labelNaranja'>¿Cuentas con alguna certificación?
                                                <IconButton sx={{ color: '#FFFFFF' }} >
                                                    <Tooltip position='top' title='Ejemplo: Certificacion con CERTIMEX, Kosher, etc.'>
                                                        <HelpOutlineIcon />
                                                    </Tooltip>
                                                </IconButton>
                                                <label className="ms-5 mt-1 texto-blanco">Si</label>
                                                <input className={`ms-2 mt-2 form-check-input ${fc_36Map.empresacertificadoracheck !== undefined ? (
                                                    fc_36Map?.empresacertificadoracheck ? 'inputDenegado'
                                                        : 'inputValidado') : ('')}`}
                                                    type="checkbox" onChange={e => {
                                                        const { ...newValues } = values
                                                        newValues.certificacionno = !e.target.checked
                                                        newValues.certificacionsi = e.target.checked
                                                        setValues(newValues)
                                                    }}
                                                    name="certificacionsi" onBlur={handleBlur}
                                                    checked={values.certificacionsi} id="si" />
                                                <label className="ms-5 texto-blanco">No</label>
                                                <input className={`ms-2 mt-2 form-check-input ${fc_36Map.empresacertificadoracheck !== undefined ? (
                                                    fc_36Map?.empresacertificadoracheck ? 'inputDenegado'
                                                        : 'inputValidado') : ('')}`}
                                                    type="checkbox" onChange={e => {
                                                        const { ...newValues } = values
                                                        newValues.certificacionno = e.target.checked
                                                        newValues.certificacionsi = !e.target.checked
                                                        setValues(newValues)
                                                    }}
                                                    name="certificacionno" onBlur={handleBlur}
                                                    checked={values.certificacionno} id="no" />
                                            </h4>
                                            {(values.certificacionsi) &&
                                                <div className='col-md-12'>
                                                    <div className="form-floating mb-3">
                                                        <input type="text" className={`form-control ${fc_36Map.empresacertificadoracheck !== undefined ? (
                                                            fc_36Map?.empresacertificadoracheck ? 'inputDenegado'
                                                                : 'inputValidado') : ('')}`}
                                                            id="Nombre rep legal" placeholder='Nombre'
                                                            name="empresacertificadora"
                                                            value={values.empresacertificadora}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        {touched.empresacertificadora && errors.empresacertificadora && <div className="text-danger">{errors.empresacertificadora}</div>}
                                                        <label className="floatingInput">Nombre de la empresa certificadora</label>
                                                        <span className={`${fc_36Map.empresacertificadoracheck !== undefined ? (fc_36Map?.empresacertificadoracheck === true ? 'text-danger' : 'text-success') : ('')}`}>
                                                            {fc_36Map?.empresacertificadoracheck === true ? (fc_36Map?.empresacertificadora) : ''}</span>
                                                    </div>
                                                </div>
                                            }
                                            {values.tipoempresa === 'fisica' &&
                                                <div className='row justify-content-start mb-2'>
                                                    <div className='row'>
                                                        <h4 className='text-center labelNaranja'>Información personal
                                                        </h4>
                                                    </div>
                                                    <hr>
                                                    </hr>

                                                    <div className='col-md-6'>
                                                        <div className="form-floating mb-3">
                                                            <input type="date" className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                                max={fechaParaMayorEdad}
                                                                id="fechadenacimiento" placeholder='Fecha de nacimiento'
                                                                name="fechadenacimiento"
                                                                value={values.fechadenacimiento}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur} />
                                                            <div className="text-danger">{dataCliente.personafisica ? 'Campo obligatorio a cambiar' :
                                                                (values.fechadenacimiento == undefined || values.fechadenacimiento === "") ? 'Campo obligatorio' : ''}</div>
                                                            <label className="floatingInput">Fecha de nacimiento</label>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-6'>
                                                        <div className="form-floating mb-3">
                                                            <select className={`form-select form-select-sm ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                                name="sexo"
                                                                value={values.sexo}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur} >
                                                                <option value="">Seleccione género</option>
                                                                <option value="Masculino">Masculino</option>
                                                                <option value="Femenino">Femenino</option>
                                                            </select>
                                                            {touched.sexo && errors.sexo && <div className="text-danger">{errors.sexo}</div>}
                                                            <label className="label-dark" htmlFor="floatingInput">Género</label>
                                                            <div className="text-danger">{dataCliente.personafisica ? 'Campo obligatorio a cambiar' :
                                                                (values.sexo == undefined || values.sexo === "") ? 'Campo obligatorio' : ''}</div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="form-floating mb-3">
                                                            <select className={`form-select form-select-sm ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                                name="estadocivil"
                                                                value={values.estadocivil}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur} >
                                                                <option value="">Seleccione estado civil</option>
                                                                <option value="Soltero">Soltero</option>
                                                                <option value="Casado">Casado</option>
                                                                <option value="Divorciado">Divorciado</option>
                                                                <option value="Viudo">Viudo</option>
                                                                <option value="Concubinato">Concubinato</option>
                                                            </select>
                                                            {touched.estadocivil && errors.estadocivil && <div className="text-danger">{errors.estadocivil}</div>}
                                                            <label className="floatingInput">Estado civil</label>
                                                            <div className="text-danger">{dataCliente.personafisica ? 'Campo obligatorio a cambiar' :
                                                                (values.estadocivil == undefined || values.estadocivil === "") ? 'Campo obligatorio' : ''}</div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="form-floating mb-3">
                                                            <select className={`form-select form-select-sm ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                                name="escolaridad"
                                                                value={values.escolaridad}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur} >
                                                                <option value="">Seleccione su escolaridad</option>
                                                                <option value="Educación preescolar">Educación preescolar</option>
                                                                <option value="Educación primaria">Educación primaria</option>
                                                                <option value="Educación secundaria">Educación secundaria</option>
                                                                <option value="Educación media superior">Educación media superior</option>
                                                                <option value="Educación superior">Educación superior</option>
                                                                <option value="Maestria">Maestria</option>
                                                                <option value="Doctorado">Doctorado</option>
                                                                <option value="Post-Doctorado">Post-Doctorado</option>
                                                            </select>
                                                            {touched.escolaridad && errors.escolaridad && <div className="text-danger">{errors.escolaridad}</div>}
                                                            <label className="floatingInput">Escolaridad</label>
                                                            <div className="text-danger">{dataCliente.personafisica ? 'Campo obligatorio a cambiar' :
                                                                (values.escolaridad == undefined || values.escolaridad === "") ? 'Campo obligatorio' : ''}</div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <label className="ms-1 label-blanco">Padece alguna discapacidad</label>
                                                        <label className="ms-3 label-blanco">Si</label>
                                                        <input className={`ms-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                            type="checkbox" //onChange={e => setDiscapacidadSiNo(e.target)}
                                                            checked={values.discapacidadsi} id="si"
                                                            name="discapacidadsi" onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.discapacidadsi = e.target.checked
                                                                newValues.discapacidadno = !e.target.checked
                                                                setValues(newValues)
                                                            }}
                                                            onBlur={handleBlur} />
                                                        <span className='text-danger'>{fc_36Map?.tipodiscapacidad}</span>
                                                        <label className="ms-3 label-blanco">No</label>
                                                        <input className={`ms-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                            type="checkbox" //onChange={e => setDiscapacidadSiNo(e.target)}
                                                            checked={values.discapacidadno} id="no"
                                                            name="discapacidadno" onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.discapacidadsi = !e.target.checked
                                                                newValues.discapacidadno = e.target.checked
                                                                setValues(newValues)
                                                            }}
                                                            onBlur={handleBlur} />
                                                        {values.discapacidadsi &&
                                                            <div className="form-floating mb-3">
                                                                <input type="text" className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                                    id="" placeholder='Tipo de discapacidad'
                                                                    name="tipodiscapacidad"
                                                                    value={values.tipodiscapacidad}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    disabled={values.discapacidadno} />
                                                                {touched.tipodiscapacidad && errors.tipodiscapacidad && <div className="text-danger">{errors.tipodiscapacidad}</div>}
                                                                <label className="floatingInput">Tipo de discapacidad:</label>
                                                                <div className="text-danger">{dataCliente.personafisica ? dataCliente.tipodiscapacidad === values.tipodiscapacidad ? 'Campo obligatorio a cambiar' : '' :
                                                                    (values.tipodiscapacidad == undefined || values.tipodiscapacidad === "") ? 'Campo obligatorio' : ''}</div>
                                                            </div>
                                                        }

                                                    </div>
                                                    <div className='col-md-6'>
                                                        <label className="ms-1 label-blanco">Habla alguna lengua indígena</label>
                                                        <label className="ms-3 label-blanco">Si</label>
                                                        <input className={`ms-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                            type="checkbox" //onChange={e => setLenguaSiNo(e.target)}
                                                            checked={values.lenguaindijenasi} id="si"
                                                            name="lenguaindijenasi" onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.lenguaindijenasi = e.target.checked
                                                                newValues.lenguaindijenano = !e.target.checked
                                                                setValues(newValues)
                                                            }}
                                                            onBlur={handleBlur} />
                                                        <span className='text-danger'>{fc_36Map?.tipolengua}</span>
                                                        <label className="ms-3 label-blanco">No</label>
                                                        <input className={`ms-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                            type="checkbox" //onChange={e => setLenguaSiNo(e.target)}
                                                            checked={values.lenguaindijenano} id="no"
                                                            name="lenguaindijenano" onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.lenguaindijenasi = !e.target.checked
                                                                newValues.lenguaindijenano = e.target.checked
                                                                setValues(newValues)
                                                            }}
                                                            onBlur={handleBlur} />
                                                        {values.lenguaindijenasi &&
                                                            <div className="form-floating mb-3">
                                                                <input type="text" className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                                    id="" placeholder='¿Cual?'
                                                                    name="tipolengua"
                                                                    value={values.tipolengua}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    disabled={values.lenguaindijenano} />
                                                                {touched.lenguaindijenasi && errors.lenguaindijenasi && <div className="text-danger">{errors.lenguaindijenasi}</div>}
                                                                <label className="floatingInput">Lengua indígena:</label>
                                                                <div className="text-danger">{dataCliente.personafisica ? dataCliente.tipolengua === values.tipolengua ? 'Campo obligatorio a cambiar' : '' :
                                                                    (values.tipolengua == undefined || values.tipolengua === "") ? 'Campo obligatorio' : ''}</div>
                                                            </div>}
                                                    </div>
                                                    <div className='col-md-9'>

                                                        <div className="form-floating mb-3">
                                                            {(!values.discapacidadsi && !values.lenguaindijenasi) && <br />}
                                                            <input type="text" className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                                id="" placeholder='¿Cual?'
                                                                name="ocupacion"
                                                                value={values.ocupacion}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur} />
                                                            {touched.ocupacion && errors.ocupacion && <div className="text-danger">{errors.ocupacion}</div>}
                                                            <label className="floatingInput">Ocupación</label>
                                                            <div className="text-danger">{dataCliente.personafisica ? dataCliente.ocupacion === values.ocupacion ? 'Campo obligatorio a cambiar' : '' :
                                                                (values.ocupacion == undefined || values.ocupacion === "") ? 'Campo obligatorio' : ''}</div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-3'>
                                                        {(!values.discapacidadsi && !values.lenguaindijenasi) && <br />}
                                                        <div className="form-floating mb-3 inputConFlechaVisible">
                                                            <input type="number" className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                                placeholder='0'
                                                                id=""
                                                                name="numerohijos"
                                                                value={values.numerohijos}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                onWheel={event => event.currentTarget.blur()} />
                                                            {touched.numerohijos && errors.numerohijos && <div className="text-danger">{errors.numerohijos}</div>}
                                                            <label className="floatingInput">Número de hijos</label>
                                                            <div className="text-danger">{dataCliente.personafisica ? dataCliente.numerohijos === values.numerohijo ? 'Campo obligatorio a cambiar' : '' :
                                                                (values.numerohijos == undefined || values.numerohijos === "") ? 'Campo obligatorio' : ''}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            <h3 className='text-center labelNaranja'>Estadística social</h3>
                                            <h5 className="label-withe" >Número de trabajadores</h5>
                                            <div className='row'>
                                                <div className='col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2'>
                                                    <br />
                                                    <div className="form-floating mb-3">
                                                        <input type="number" id="floatingInput"
                                                            className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                            placeholder='0'
                                                            name="numerohombres" min='0'
                                                            value={values.numerohombres}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            onWheel={event => event.currentTarget.blur()}
                                                        />
                                                        {touched.numerohombres && errors.numerohombres && <div className="text-danger">{errors.numerohombres}</div>}
                                                        <span className='text-danger'>{fc_36Map?.numerohombres}</span>
                                                        <label className="label-dark" htmlFor="floatingInput"><small>No. de hombres</small></label>
                                                    </div>
                                                </div>
                                                <div className='col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2'>
                                                    <br />
                                                    <div className="form-floating mb-3">
                                                        <input type="number" id="floatingInput"
                                                            className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                            placeholder='0'
                                                            name="numeromujeres" min='0'
                                                            value={values.numeromujeres}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            onWheel={event => event.currentTarget.blur()}
                                                        />
                                                        {touched.numeromujeres && errors.numeromujeres && <div className="text-danger">{errors.numeromujeres}</div>}
                                                        <span className='text-danger'>{fc_36Map?.numeromujeres}</span>

                                                        <label className="label-dark" htmlFor="floatingInput"><small>No. de mujeres</small></label>
                                                    </div>
                                                </div>
                                                <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3'>
                                                    <br />
                                                    <div className="form-floating mb-3">
                                                        <input type="number" id="floatingInput"
                                                            className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                            placeholder='0'
                                                            name="numerodiscapacitados" min='0'
                                                            value={values.numerodiscapacitados}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            onWheel={event => event.currentTarget.blur()}
                                                        />
                                                        {touched.numerodiscapacitados && errors.numerodiscapacitados && <div className="text-danger">{errors.numerodiscapacitados}</div>}
                                                        <span className='text-danger'>{fc_36Map?.numerodiscapacitados}</span>

                                                        <label className="label-dark" htmlFor="floatingInput"><small>No. de discapacitados</small></label>
                                                    </div>
                                                </div>
                                                <div className='col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2'>
                                                    <label className="label-blanco">Base</label>
                                                    <div className="form-floating mb-3">
                                                        <input type="number" id="floatingInput"
                                                            className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                            placeholder='0'
                                                            name="numerobase" min='0'
                                                            value={values.numerobase}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            onWheel={event => event.currentTarget.blur()}
                                                        />
                                                        {touched.numerobase && errors.numerobase && <div className="text-danger">{errors.numerobase}</div>}
                                                        <span className='text-danger'>{fc_36Map?.numerobase}</span>

                                                        <label className="label-dark" htmlFor="floatingInput"><small>No. de personas</small></label>
                                                    </div>
                                                </div>
                                                <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3'>
                                                    <label className="label-blanco">Eventuales</label>
                                                    <div className="form-floating mb-3">
                                                        <input type="number" id="floatingInput"
                                                            className={`form-control ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                            placeholder='0'
                                                            name="numeroeventuales" min='0'
                                                            value={values.numeroeventuales}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            onWheel={event => event.currentTarget.blur()}
                                                        />
                                                        {touched.numeroeventuales && errors.numeroeventuales && <div className="text-danger">{errors.numeroeventuales}</div>}
                                                        <span className='text-danger'>{fc_36Map?.numeroeventuales}</span>

                                                        <label className="label-dark" htmlFor="floatingInput"><small>No. de personas</small></label>
                                                    </div>
                                                </div>
                                            </div>
                                        </Fragment>
                                    }
                                    {values.actualizacioncadena &&
                                        <Fragment>
                                            <div className='row'>
                                                <h6 className='text-center labelNaranja'>ACTIVIDAD DE LA EMPRESA DENTRO DE LA CADENA PRODUCTIVA MAGUEY-MEZCAL</h6>
                                            </div>
                                            <div className={`row text-center ${estilos.divSoloBorderNaranja}`}>
                                                <div className='row text-center'>
                                                    <span className='text-center'><b>NOTA:</b> Sí desea darse de baja o alta en uno de sus eslabones activos, deberá desactivar o activar la casilla correspondiente.</span><br /><br />
                                                    <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center'>
                                                        <input className={`form-check-input me-3 escalar ${fc_36Map.cadenaproductivacheck !== undefined ? (
                                                            fc_36Map?.representantelegalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            type="checkbox"
                                                            checked={values.viverista} id="noAsociado"
                                                            name="viverista"
                                                            onChange={e => {
                                                                e.target.checked === false ?
                                                                    botonBajaCadena(values, 'viveristabaja') :
                                                                    e.target.checked === true ?
                                                                        altabajaCadena(values, 'viveristaalta') : ''
                                                            }}
                                                            onBlur={handleBlur} />
                                                        <span className='text-danger'>{fc_36Map?.viverista}</span>
                                                        <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                            <h5>Viverista</h5>
                                                        </label>
                                                    </div>
                                                    <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                                                        <input className={`form-check-input me-3 escalar ${fc_36Map.cadenaproductivacheck !== undefined ? (
                                                            fc_36Map?.cadenaproductivacheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            type="checkbox"
                                                            checked={values.productormaguey} id="noAsociado"
                                                            name="productormaguey"
                                                            onChange={e => {
                                                                e.target.checked === false ?
                                                                    botonBajaCadena(values, 'productormagueybaja') :
                                                                    e.target.checked === true ?
                                                                        altabajaCadena(values, 'productormagueyalta') : ''
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                        <span className='text-danger'>{fc_36Map?.productormaguey}</span>
                                                        <label className="form-check-label border-secondary"
                                                            htmlFor="flexCheckChecked">
                                                            <h5>Productor de maguey</h5>
                                                        </label>
                                                    </div>
                                                    <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                                                        <input className={`form-check-input me-3 escalar ${fc_36Map.cadenaproductivacheck !== undefined ? (
                                                            fc_36Map?.representantelegalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            type="checkbox"
                                                            checked={values.productormezcal} id="noAsociado"
                                                            name="productormezcal"
                                                            onChange={e => {
                                                                e.target.checked === false ?
                                                                    botonBajaCadena(values, 'productormezcalbaja') :
                                                                    e.target.checked === true ?
                                                                        altabajaCadena(values, 'productormezcalalta') : ''
                                                            }}
                                                            onBlur={handleBlur} />
                                                        <label className="form-check-label border-secondary"
                                                            htmlFor="flexCheckChecked">
                                                            <h5>Productor de mezcal</h5>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className='row' style={{ paddingTop: '3%' }}>
                                                    <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center'>
                                                        <input className={`form-check-input me-3 escalar ${fc_36Map.cadenaproductivacheck !== undefined ? (
                                                            fc_36Map?.representantelegalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            type="checkbox"
                                                            //     onChange={e => setEnvasador(e.target.checked)}
                                                            checked={values.envasador} id="noAsociado"
                                                            name="envasador"
                                                            onChange={e => {
                                                                e.target.checked === false ?
                                                                    botonBajaCadena(values, 'envasadorbaja') :
                                                                    e.target.checked === true ?
                                                                        altabajaCadena(values, 'envasadoralta') : ''
                                                            }}
                                                            onBlur={handleBlur} />
                                                        <span className='text-danger'>{fc_36Map?.envasador}</span>
                                                        <label className="form-check-label me-4 text-center"
                                                            htmlFor="flexCheckChecked">
                                                            <h5 className='text-center'>Envasador</h5>
                                                        </label>
                                                    </div>
                                                    <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center'>
                                                        <input className={`form-check-input me-3 escalar ${fc_36Map.cadenaproductivacheck !== undefined ? (
                                                            fc_36Map?.representantelegalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            type="checkbox"
                                                            checked={values.comercializadormezcal} id="noAsociado"
                                                            name="comercializadormezcal"
                                                            onChange={e => {
                                                                e.target.checked === false ?
                                                                    botonBajaCadena(values, 'comercializadormezcalbaja') :
                                                                    e.target.checked === true ?
                                                                        altabajaCadena(values, 'comercializadormezcalalta') : ''
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                        <label className="form-check-label me-4" htmlFor="flexCheckChecked">
                                                            <h5>Comercializador de</h5>
                                                        </label>
                                                        <label className="form-check-label me-4" htmlFor="flexCheckChecked">
                                                            <h5>mezcal</h5>
                                                        </label>
                                                        <span className='text-danger'>{fc_36Map?.comercializadormezcal}</span>
                                                    </div>
                                                    <div className='col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center'>
                                                        <input className={`form-check-input me-3 escalar ${fc_36Map.cadenaproductivacheck !== undefined ? (
                                                            fc_36Map?.representantelegalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                            type="checkbox"
                                                            checked={values.comercializadorbebidas} id="noAsociado"
                                                            name="comercializadorbebidas"
                                                            onChange={e => {
                                                                e.target.checked === false ?
                                                                    botonBajaCadena(values, 'comercializadorbebidasbaja') :
                                                                    e.target.checked === true ?
                                                                        altabajaCadena(values, 'comercializadorbebidasalta') : ''
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                        <label className="form-check-label me-2 " htmlFor="flexCheckChecked">
                                                            <h5>Comercializador de</h5>
                                                        </label>
                                                        <label className="form-check-label me-1 " htmlFor="flexCheckChecked">
                                                            <h5>bebidas con mezcal</h5>
                                                        </label>
                                                        <span className='text-danger'>{fc_36Map?.comercializadorbebidas}</span>

                                                    </div>
                                                </div>
                                            </div>

                                        </Fragment>
                                    }
                                    {(values.actualizarmedioscontacto || values.cambiorazon) &&
                                        <Fragment>
                                            {(values.actualizarmedioscontacto && !values.cambiorazon) &&
                                                <h6 className='text-center me-5 labelNaranja mt-3'>ACTUALIZACIÓN DE MEDIOS DE CONTACTO</h6>
                                            }
                                            {values.cambiorazon &&
                                                <h4 className='text-center labelNaranja mt-3'>¿Desea actualizar sus medios de contacto?

                                                    <label className="ms-5 mt-1 texto-blanco">Si</label>
                                                    <input className={`ms-2 mt-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                        type="checkbox" onChange={e => {
                                                            const { ...newValues } = values
                                                            newValues.medioscontactono = !e.target.checked
                                                            newValues.medioscontactosi = e.target.checked
                                                            setValues(newValues)
                                                        }}
                                                        name="medioscontactosi" onBlur={handleBlur}
                                                        checked={values.medioscontactosi} id="si" />

                                                    <label className="ms-5 texto-blanco">No</label>
                                                    <input className={`ms-2 mt-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                        type="checkbox" onChange={e => {
                                                            const { ...newValues } = values
                                                            newValues.medioscontactono = e.target.checked
                                                            newValues.medioscontactosi = !e.target.checked
                                                            setValues(newValues)
                                                        }}
                                                        name="medioscontactono" onBlur={handleBlur}
                                                        checked={values.medioscontactono} id="no" />
                                                </h4>
                                            }
                                            {values.medioscontactosi &&
                                                <div className={`row  ${estilos.divSoloBorderNaranja}`}>
                                                    <TablaMediosContacto api={{ handdle: handdleMediosContacto, handdleRemovePrev: handdleRemovePrevMediosContacto, handdleEditPrev: handdleEditPrevMediosContacto, mediosContacto, handdleMediosContactoBaja/*, handdleMediosContactoAlta*/ }} productosMap={anexoContactosMap} />
                                                </div>
                                            }

                                        </Fragment>
                                    }
                                    {values.cambioresponsable &&
                                        <Fragment>
                                            {values.cambioresponsable && !values.cambiorazon &&
                                                <h4 className='text-center me-5 labelNaranja mt-2'>CAMBIOS DE REPRESENTANTE LEGAL</h4>}
                                            {values.cambiorazon &&
                                                <h4 className='text-center labelNaranja mt-3'>¿Desea actualizar sus representantes legales?
                                                    <label className="ms-5 mt-1 texto-blanco">Si</label>
                                                    <input className={`ms-2 mt-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                        type="checkbox" onChange={e => {
                                                            const { ...newValues } = values
                                                            newValues.repesentantelegalno = !e.target.checked
                                                            newValues.repesentantelegalsi = e.target.checked
                                                            setValues(newValues)
                                                        }}
                                                        name="repesentantelegalsi" onBlur={handleBlur}
                                                        checked={values.repesentantelegalsi} id="si" />

                                                    <label className="ms-5 texto-blanco">No</label>
                                                    <input className={`ms-2 mt-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                        type="checkbox" onChange={e => {
                                                            const { ...newValues } = values
                                                            newValues.repesentantelegalno = e.target.checked
                                                            newValues.repesentantelegalsi = !e.target.checked
                                                            setValues(newValues)
                                                        }}
                                                        name="repesentantelegalno" onBlur={handleBlur}
                                                        checked={values.repesentantelegalno} id="no" />
                                                </h4>}
                                            {values.repesentantelegalsi &&
                                                <div className={`row  ${estilos.divSoloBorderNaranja}`}>
                                                    <TablaRepresentantesLegales api={{ handdle: handdleResponsablesLegales, handdleRemovePrev: handdleRemovePrevResponsablesLegales, handdleEditPrev: handdleEditPrevResponsablesLegales, responsablesLegales, handdleApoderadosLegalesBaja/*, handdleApoderadosLegalesAlta*/ }} productosMap={anexoRepresentantesMap} />
                                                </div>}
                                        </Fragment>
                                    }
                                    {values.cambiorepresentante &&
                                        <Fragment>
                                            {values.cambiorepresentante && !values.cambiorazon &&
                                                <h6 className='text-center me-5 labelNaranja mt-2'>CAMBIOS DE REPRESENTANTE AUTORIZADO</h6>}
                                            {values.cambiorazon &&
                                                <h4 className='text-center labelNaranja mt-3'>¿Desea actualizar sus representantes autorizados?
                                                    <label className="ms-5 mt-1 texto-blanco">Si</label>
                                                    <input className={`ms-2 mt-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                        type="checkbox" onChange={e => {
                                                            const { ...newValues } = values
                                                            newValues.personaautorizadano = !e.target.checked
                                                            newValues.personaautorizadasi = e.target.checked
                                                            setValues(newValues)
                                                        }}
                                                        name="personaautorizadasi" onBlur={handleBlur}
                                                        checked={values.personaautorizadasi} id="si" />

                                                    <label className="ms-5 texto-blanco">No</label>
                                                    <input className={`ms-2 mt-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                        type="checkbox" onChange={e => {
                                                            const { ...newValues } = values
                                                            newValues.personaautorizadano = e.target.checked
                                                            newValues.personaautorizadasi = !e.target.checked
                                                            setValues(newValues)
                                                        }}
                                                        name="personaautorizadano" onBlur={handleBlur}
                                                        checked={values.personaautorizadano} id="no" />
                                                </h4>}
                                            {values.personaautorizadasi &&
                                                <div className={`row  ${estilos.divSoloBorderNaranja}`}>
                                                    <TablaPersonasAutorizadas api={{ handdle: handdlePersonaAutorizada, handdleRemovePrev: handdleRemovePrevPersonaAutorizada, handdleEditPrev: handdleEditPrevPersonaAutorizada, personaAutorizada, handdlePersonaAutorizadaBaja/*, handdlePersonaAutorizadaAlta*/ }} productosMap={anexoPersonaAutorizadaMap} />
                                                </div>}
                                        </Fragment>
                                    }
                                    {values.actualizaciondomicilio &&
                                        <div className='row justify-content-start'>
                                            {values.actualizaciondomicilio && !values.cambiorazon &&
                                                <h6 className='text-center me-5 labelNaranja mt-2'>DOMICILIO FISCAL </h6>}
                                            {values.cambiorazon &&
                                                <h4 className='text-center labelNaranja mt-3'>¿Desea actualizar su domicilios fiscal y sucursales?
                                                    <label className="ms-5 mt-1 texto-blanco">Si</label>
                                                    <input className={`ms-2 mt-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                        type="checkbox" onChange={e => {
                                                            const { ...newValues } = values
                                                            newValues.domiciliofiscalno = !e.target.checked
                                                            newValues.domiciliofiscalsi = e.target.checked
                                                            setValues(newValues)
                                                        }}
                                                        name="domiciliofiscalsi" onBlur={handleBlur}
                                                        checked={values.domiciliofiscalsi} id="si" />

                                                    <label className="ms-5 texto-blanco">No</label>
                                                    <input className={`ms-2 mt-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                        type="checkbox" onChange={e => {
                                                            const { ...newValues } = values
                                                            newValues.domiciliofiscalno = e.target.checked
                                                            newValues.domiciliofiscalsi = !e.target.checked
                                                            setValues(newValues)
                                                        }}
                                                        name="domiciliofiscalno" onBlur={handleBlur}
                                                        checked={values.domiciliofiscalno} id="no" />
                                                </h4>}
                                            {values.domiciliofiscalsi &&
                                                <TablaDomicilio api={{ handdleDomiclio, handdleRemoveDomicilioPrev, handdleEditDomicilioPrev, domicilio, handdleDomicilioFiscalBaja/*, handdleDomicilioFiscalAlta, handdleDomicilioFiscalSucursal*/ }} productosMap={anexoDomicilioFiscalMap} />
                                            }
                                        </div>
                                    }
                                </div>

                                : nombresParaPaginas[paginaActiva - 1] === 'Predios/Viveros' ?
                                    <div>
                                        {((!dataCliente.viverista && viveristaaltabaja) || (values.actualizacionprediosviveros && dataCliente.viverista) || values.cambiorazon) &&
                                            <Fragment>
                                                {((!dataCliente.viverista && viveristaaltabaja) || (values.actualizacionprediosviveros && dataCliente.viverista) && !values.cambiorazon) &&
                                                    ((values.actualizacionprediosviveros && !values.cambiorazon) ? <h6 className='text-center me-5 labelNaranja mt-2'>BAJA DE VIVEROS</h6> :
                                                        <h6 className='text-center me-5 labelNaranja mt-2'>ACTUALIZACIÓN DE VIVEROS</h6>)}
                                                {values.cambiorazon && fc_36.viverista &&
                                                    <h4 className='text-center labelNaranja mt-3'>¿Desea actualizar sus viveros?
                                                        <label className="ms-5 mt-1 texto-blanco">Si</label>
                                                        <input className={`ms-2 mt-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                            type="checkbox" onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.actualizacionviverosno = !e.target.checked
                                                                newValues.actualizacionviverossi = e.target.checked
                                                                setValues(newValues)
                                                            }}
                                                            name="actualizacionviverossi" onBlur={handleBlur}
                                                            checked={values.actualizacionviverossi} id="si" />

                                                        <label className="ms-5 texto-blanco">No</label>
                                                        <input className={`ms-2 mt-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                            type="checkbox" onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.actualizacionviverosno = e.target.checked
                                                                newValues.actualizacionviverossi = !e.target.checked
                                                                setValues(newValues)
                                                            }}
                                                            name="actualizacionviverosno" onBlur={handleBlur}
                                                            checked={values.actualizacionviverosno} id="no" />
                                                    </h4>}
                                                {(values.actualizacionviverossi || viveros.filter(anexo => anexo.baja == true).length > 0) && fc_36.viverista &&
                                                    <div className={`row  ${estilos.divSoloBorderNaranjaPreViv}`}>
                                                        <TablaVivero api={{ handdleVivero, handdleRemoveViveroPrev, handdleEditViveroPrev, viveros, handdleViverosBaja }} productosMap={anexoViverosMap}
                                                            actualizacionprediosviveros={values.actualizacionprediosviveros} />
                                                    </div>}
                                            </Fragment>}
                                        {((!dataCliente.productormaguey && productormagueyaltabaja) || (values.actualizacionprediosviveros && dataCliente.productormaguey) || values.cambiorazon) &&
                                            <Fragment>
                                                {((!dataCliente.productormaguey && productormagueyaltabaja) || (values.actualizacionprediosviveros && dataCliente.productormaguey) && !values.cambiorazon) &&
                                                    ((values.actualizacionprediosviveros && !values.cambiorazon) ? <h6 className='text-center me-5 labelNaranja mt-2'>BAJA DE PREDIOS</h6> :
                                                        <h6 className='text-center me-5 labelNaranja mt-2'>ACTUALIZACIÓN DE PREDIOS</h6>)}
                                                {values.cambiorazon && fc_36.productormaguey &&
                                                    <h4 className='text-center labelNaranja mt-3'>¿Desea actualizar sus predios?
                                                        <label className="ms-5 mt-1 texto-blanco">Si</label>
                                                        <input className={`ms-2 mt-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                            type="checkbox" onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.actualizacionprediosno = !e.target.checked
                                                                newValues.actualizacionprediossi = e.target.checked
                                                                setValues(newValues)
                                                            }}
                                                            name="actualizacionprediossi" onBlur={handleBlur}
                                                            checked={values.actualizacionprediossi} id="si" />

                                                        <label className="ms-5 texto-blanco">No</label>
                                                        <input className={`ms-2 mt-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                            type="checkbox" onChange={e => {
                                                                const { ...newValues } = values
                                                                newValues.actualizacionprediosno = e.target.checked
                                                                newValues.actualizacionprediossi = !e.target.checked
                                                                setValues(newValues)
                                                            }}
                                                            name="actualizacionprediosno" onBlur={handleBlur}
                                                            checked={values.actualizacionprediosno} id="no" />
                                                    </h4>}
                                                {values.actualizacionprediossi &&
                                                    <div className={`row  ${estilos.divSoloBorderNaranjaPreViv}`}>
                                                        <TablaPredio api={{ handdlePredio, handdleRemovePredioPrev, handdleEditPredioPrev, predios, handdlePrediosBaja }} productosMap={anexoPrediosMap}
                                                            actualizacionprediosviveros={values.actualizacionprediosviveros} />
                                                    </div>}
                                            </Fragment>
                                        }

                                    </div>

                                    : nombresParaPaginas[paginaActiva - 1] === 'Instalaciones' ?
                                        <div>

                                            {(values.actualizacioninstalaciones && !values.cambiorazon) || (values.actualizacioncadena && !values.cambiorazon) &&
                                                <h6 className='text-center me-5 labelNaranja mt-2'>ACTUALIZACIÓN DE INSTALACIONES</h6>}
                                            {values.cambiorazon &&
                                                <h4 className='text-center labelNaranja mt-3'>¿Desea actualizar sus instalaciones?
                                                    <label className="ms-5 mt-1 texto-blanco">Si</label>
                                                    <input className={`ms-2 mt-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                        type="checkbox" onChange={e => {
                                                            const { ...newValues } = values
                                                            newValues.actualizacioninstalacionno = !e.target.checked
                                                            newValues.actualizacioninstalacionsi = e.target.checked
                                                            setValues(newValues)
                                                        }}
                                                        name="actualizacioninstalacionsi" onBlur={handleBlur}
                                                        checked={values.actualizacioninstalacionsi} id="si" />

                                                    <label className="ms-5 texto-blanco">No</label>
                                                    <input className={`ms-2 mt-2 form-check-input ${JSON.stringify({}) !== JSON.stringify(fc_36Map) ? ('inputValidado') : ('')}`}
                                                        type="checkbox" onChange={e => {
                                                            const { ...newValues } = values
                                                            newValues.actualizacioninstalacionno = e.target.checked
                                                            newValues.actualizacioninstalacionsi = !e.target.checked
                                                            setValues(newValues)
                                                        }}
                                                        name="actualizacioninstalacionno" onBlur={handleBlur}
                                                        checked={values.actualizacioninstalacionno} id="no" />
                                                </h4>}
                                            {(values.actualizacioninstalacionsi || (values.actualizacioncadena && !values.cambiorazon)) &&
                                                <div className='row justify-content-start'>
                                                    {!modoCorreccion &&
                                                        <Fragment>
                                                            {((values.actualizacioninstalaciones && fc_36.productormezcal) || (productormezcalaltabaja && fc_36.productormezcal) ||
                                                                (values.actualizacioninstalacionsi && fc_36.productormezcal)) &&
                                                                <div className="mt-3 col-md-4">
                                                                    <button type="submit"
                                                                        onClick={() => { props.history.push('/fc_36AnexoProduccion'),/*handleOpenModalPregunta(),*/ guardarDatos(values) }}
                                                                        className={`btn btn-success`} //disabled={!anexounidadproduccion}estilos.botonNaranja
                                                                    > Agregar anexo unidad produccion</button>
                                                                </div>
                                                            }
                                                            {((values.actualizacioninstalaciones && fc_36.envasador) || (envasadoraltabaja && fc_36.envasador) || 
                                                            (values.actualizacioninstalacionsi && fc_36.envasador)) &&
                                                                <div className="mt-3 col-md-4">
                                                                    <button type="submit" onClick={() => { props.history.push('/fc_36AnexoEnvasado'), guardarDatos(values) }}
                                                                        className={`btn btn-success`} //disabled={!anexounidadenvasado}
                                                                    >Agregar anexo unidad envasado</button>
                                                                </div>
                                                            }
                                                            {((values.actualizacioninstalaciones && (fc_36.comercializadormezcal || fc_36.comercializadorbebidasmezcal)) ||
                                                                (fc_36.comercializadormezcalaltabaja && fc_36.comercializadormezcal) || (fc_36.comercializadorbebidasaltabaja && fc_36.comercializadorbebidas) ||
                                                                (productormezcalaltabaja && fc_36.productormezcal) || (envasadoraltabaja && fc_36.envasador) || (fc_36.actualizacioncadena && (fc_36.productormezcal ||
                                                                    fc_36.envasador || fc_36.comercializadormezcal || fc_36.comercializadorbebidas)
                                                                )) &&
                                                                <div className="mt-3 col-md-4">
                                                                    <button type="submit"
                                                                        onClick={() => { botonAgregarAnexoAlmacen() }}
                                                                        className={`btn btn-success`} //disabled={!anexounidadalmacen}
                                                                    >Agregar anexo unidad almacén</button>
                                                                </div>
                                                            }
                                                        </Fragment>}
                                                    <br /><br />
                                                    <TablaAnexosFC36 rows={anexoInstalaciones} handdleDeleteOptionFile={handdleDeleteOptionFileInstalacion} api={{ handdleInstalacionesBaja, handdleInstalacionesAlta }} />
                                                    <div className="text-danger">{errors.errorInstalacion}</div>

                                                </div>
                                            }
                                            <br />
                                        </div>
                                        : nombresParaPaginas[paginaActiva - 1] === 'Marcas' ?
                                            <Fragment>
                                                {((values.actualizacioncadena && fc_36.comercializadormezcal && fc_36.comercializadormezcalaltabaja) || (values.actualizarmarcas && fc_36.comercializadormezcal)) &&
                                                    <div className='row justify-content-start'>
                                                        <h6 className='text-center me-5 labelNaranja'>ACTUALIZACIÓN DE MARCAS<br /></h6>
                                                        <div className={`row  ${estilos.divSoloBorderNaranjaPreViv}`}>
                                                            <TablaMarcas api={{ handdle: handdleMarcas, handdleRemovePrev: handdleRemovePrevMarcas, handdleEditPrev: handdleEditPrevMarcas, marcas, handdleMarcasBaja/*, handdleMarcasAlta*/ }} productosMap={anexoMarcasMap} />
                                                            {values.cambiorazon && values.comercializadormezcal &&
                                                                <span className='text-danger text-start'>Debe de registrar nuevamente sus marcas de mezcal a comercilizar</span>}
                                                        </div><br />


                                                    </div>
                                                }
                                                {((values.actualizacioncadena && fc_36.comercializadorbebidas && fc_36.comercializadorbebidasaltabaja) || (values.actualizarmarcas && fc_36.comercializadorbebidas)) &&
                                                    <div className='row justify-content-start mt-2'>
                                                        <h6 className='text-center me-5 labelNaranja'>ACTUALIZACIÓN DE MARCAS CON BEBIDAS CON MEZCAL<br /></h6>
                                                        <div className={`row  ${estilos.divSoloBorderNaranjaPreViv}`}>
                                                            <TablaMarcasBebidasConMezcal api={{ handdle: handdleMarcasBebidas, handdleRemovePrev: handdleRemovePrevMarcasBebidas, handdleEditPrev: handdleEditPrevMarcasBebidas, marcasBebidas, /*handdleMarcasBebidaAlta,*/ handdleMarcasBebidaBaja }} productosMap={anexoMarcasBebidaMap} />
                                                            {values.cambiorazon && values.comercializadorbebidas &&
                                                                <span className='text-danger text-start'>Debe de registrar nuevamente sus marcas de bebidas con mezcal a comercilizar</span>}
                                                        </div>
                                                    </div>
                                                }
                                            </Fragment>
                                            : nombresParaPaginas[paginaActiva - 1] === 'Responsables de Instalaciones' ?
                                                <Fragment>
                                                    <div className='row justify-content-start'>
                                                        <h6 className='text-center me-5 labelNaranja'>ACTUALIZACIÓN DE RESPONSABLES DE INSTALACIÓN<br /></h6>
                                                    </div>
                                                    <TablaResponsablesInstalaciones api={{
                                                        handdle: handdleResponsableInstalaciones, handdleRemovePrev: handdleRemovePrevResponsableInstalaciones,
                                                        handdleEditPrev: handdleEditPrevResponsableInstalaciones, responsableInst, handdleResponsableInstalacionBaja,
                                                        /*handdleResponsableInstalacionAlta,*/ handdleResponsableInstalacionAlias
                                                    }}
                                                        tipoInstalaciones={tipoInstalaciones} alias={filtroalias} productosMap={anexoResponsablesInstMap} />
                                                </Fragment>
                                                : nombresParaPaginas[paginaActiva - 1] === 'Documentación' ?
                                                    <div className=" text-align: justify"> <br />
                                                        {modoCorreccion &&
                                                            <div className={`row col-md-12`} style={{ marginLeft: '-9%' }}>
                                                                <DocumentacionFC_36Component />
                                                            </div>
                                                        }
                                                        <div className='row justify-content-start'>
                                                            <TerminosYCondicionesComponent terminosYCondiciones={terminosYCondiciones} formato={'fc_36'} />
                                                        </div> <br />
                                                        {!modoCorreccion ?
                                                            <div>
                                                                <div className="row mt-4">
                                                                    {modoEdicionBorrador ?
                                                                        <div className="d-grid gap-2 col-2 mx-auto">
                                                                            <button type="submit"
                                                                                onClick={() => { botonEnviarSolicitudBorradorFC_36(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                                className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                                disabled={!terminosYCondiciones}>Enviar borrador</button>
                                                                        </div> :
                                                                        <div className="d-grid gap-2 col-2 mx-auto">
                                                                            <button type="submit"
                                                                                onClick={() => { botonEnviarSolicitudFC_36(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                                className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                                disabled={!terminosYCondiciones}>Enviar</button>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div> :
                                                            <div className="row mt-4">
                                                                <div className="d-grid gap-2 col-2 mx-auto">
                                                                    <button type="submit"
                                                                        onClick={() => { botonEnviarCorreccionesFC_36(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                        className={`btn ${estilos.botonNaranjaRedondo}`} disabled={!terminosYCondiciones}>Enviar correcciones</button>
                                                                </div>
                                                            </div>
                                                        } <br />
                                                    </div> : ''
                            }<br />
                            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
                            {envioCorrecto && <ModalEnviadoCorrectamente folioSolicitud={folio}></ModalEnviadoCorrectamente>}
                            <BotonAtrasSiguienteComponent botonSiguiente={paginaSiguiente} botonAnterior={paginaAnterior} paginaActiva={paginaActiva} totalDePaginas={paginas.length} valores={values} />
                            {modalComponent()}
                            {modalComponentBaja()}
                            {modalComponentPregunta()}
                        </div >
                    </form>
                )}
            </Formik>
        </Fragment >
    )
}
export default withRouter(FormularioFC36BeneficiarioComponent)